<template>
  <v-app class="consulta-chat-page" style="background-color: #f8f9fb">
    <v-container class="mx-12 mt-8">
      <v-row align="center" class="custom-gray-background fill-width d-flex">
        <v-col cols="12" sm="2">
          <span>Data Inicial</span>
          <v-menu
            v-model="menuDataInicio"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template #activator="{ on }">
              <v-text-field
                v-model="filtroDataInicioFormatada"
                label="Data Inicial"
                dense
                solo-inverted
                readonly
                v-on="on"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              no-title
              v-model="filtroDataInicio"
              @input="menuDataInicio = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="2">
          <span>Data Final</span>
          <v-menu
            v-model="menuDataFim"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template #activator="{ on }">
              <v-text-field
                v-model="filtroDataFimFormatada"
                label="Data Final"
                dense
                solo-inverted
                readonly
                v-on="on"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              no-title
              v-model="filtroDataFim"
              @input="menuDataFim = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="2">
          <span>Status</span>
          <v-select
            v-model="protocolStatusFilter"
            :items="statusFilterOptions"
            item-text="label"
            item-value="value"
            dense
            solo-inverted
            hide-details
          >
            <template v-slot:selection="{ item }">
              <v-icon small left :color="item.color">
                {{ item.icon }}
              </v-icon>
              <span>{{ item.label }}</span>
            </template>
            <template v-slot:item="{ item }">
              <v-icon small left :color="item.color">
                {{ item.icon }}
              </v-icon>
              <span>{{ item.label }}</span>
            </template>
          </v-select>
        </v-col>

        <v-col cols="12" sm="2">
          <span>Empresa</span>
          <v-select
            v-model="selectedEmpresa"
            :items="empresasFiltradas"
            label="Empresa"
            dense
            solo-inverted
            hide-details
            clearable
          ></v-select>
        </v-col>

        <v-col cols="12" sm="2">
          <span>Fila</span>
          <v-autocomplete
            v-model="selectedFilas"
            :items="filaFilterOptions"
            :loading="loadingFilas"
            :disabled="!selectedEmpresa || loadingFilas"
            item-text="label"
            item-value="value"
            dense
            solo-inverted
            hide-details
            clearable
            multiple
            small-chips
            deletable-chips
            label="Todas"
            no-data-text="Nenhuma fila encontrada"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="auto" class="d-flex align-end pb-0 pl-0">
          <v-btn
            color="primary"
            @click="buscarProtocolos"
            :loading="loadingProtocols"
            class="mt-1"
            small
            :disabled="!empresaSelecionada"
          >
            <v-icon left>mdi-magnify</v-icon>
            Buscar
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row class="ml-4">
        <v-col cols="12" sm="6" lg="4">
          <base-material-stats-card
            color="primary"
            icon="mdi-account"
            title="Protocolos"
            :valuex="false"
            :value="totalFilteredProtocols"
            sub-text="Total de protocolos filtrados"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="4">
          <base-material-stats-card
            color="info"
            icon="mdi-message-text-outline"
            title="Mensagens"
            :valuex="false"
            :value="totalMessages"
            sub-text="Total de mensagens filtradas"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="4">
          <base-material-stats-card
            color="warning"
            icon="mdi-account-clock-outline"
            title="Cliente sem resposta"
            :valuex="false"
            :value="openProtocolsLastCustomerMessage"
            sub-text="Protocolos abertos aguardando retorno"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <br /><br />

    <v-container style="background-color: #eee">
      <base-material-card
        color="primary"
        icon="mdi-chat"
        class="v-card--material-stats"
        style="margin-top: 20px !important; padding-top: 10px !important"
      >
        <!-- Authentication Status -->
        <v-alert v-if="!isAuthenticated" type="info" outlined class="mx-4 mt-2">
          Autenticando...
        </v-alert>
        <v-alert v-if="authError" type="error" outlined class="mx-4 mt-2">
          Erro na autenticação: {{ authError }}
        </v-alert>

        <!-- Layout Principal: Lista de Protocolos (esquerda) e Chat (direita) -->
        <v-container v-if="isAuthenticated" fluid class="pt-0 consulta-chat-layout">
          <v-row class="mt-2 consulta-chat-row">
            <!-- Coluna Esquerda: Lista de Protocolos -->
            <v-col
              :cols="12"
              :md="showingClientDetails ? 3 : 4"
              v-if="!showingClientDetails"
              v-show="!isMobile || !currentProtocol"
              class="protocols-panel"
            >
              <!-- Lista de Protocolos -->
              <v-card
                outlined
                class="protocols-card"
                style="
                  height: calc(100vh - 200px);
                  display: flex;
                  flex-direction: column;
                "
              >
                <!-- Título e Campo de Busca -->
                <div
                  class="pa-3"
                  style="flex-shrink: 0; border-bottom: 1px solid #e0e0e0"
                >
                  <div class="d-flex align-center mb-3">
                    <span class="subtitle-1 font-weight-bold">Protocolos</span>
                    <v-spacer></v-spacer>
                  </div>

                  <!-- Campo de busca -->
                  <v-text-field
                    v-model="protocolSearch"
                    label="Filtrar por protocolo ou contato"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    clearable
                    hide-details="auto"
                  ></v-text-field>
                </div>
                <!-- Lista de Protocolos -->
                <div
                  style="
                    flex: 1;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                    min-height: 0;
                  "
                >
                  <v-skeleton-loader
                    v-if="loadingProtocols"
                    type="list-item-three-line"
                  ></v-skeleton-loader>
                  <div
                    v-else
                    class="protocols-list-container"
                    style="flex: 1; overflow-y: auto"
                  >
                    <v-list dense class="py-0">
                      <v-list-item
                        v-for="protocol in filteredProtocols"
                        :key="protocol.protocolo"
                        @click="selectProtocol(protocol)"
                        :class="{
                          'primary lighten-5':
                            currentProtocol === protocol.protocolo,
                        }"
                        class="px-3"
                        style="
                          cursor: pointer;
                          border-bottom: 1px solid #e0e0e0;
                        "
                      >
                        <v-list-item-content class="py-2">
                          <v-list-item-title
                            class="font-weight-bold mb-2 d-flex align-center justify-space-between"
                            style="min-height: 36px"
                          >
                            <div class="d-flex align-center">
                              <v-icon small color="primary" class="mr-1"
                                >mdi-phone</v-icon
                              >
                              <span>{{ protocol.numeroDoContato }}</span>
                            </div>

                            <v-badge
                              v-if="protocol.alerta"
                              color="red"
                              overlap
                              class="mr-4"
                              dot
                            >
                              <v-icon small>mdi-bell</v-icon>
                            </v-badge>
                          </v-list-item-title>

                          <!-- Informações do cliente em destaque -->
                          <div
                            v-if="protocol.clienteId || protocol.clienteNome"
                            class="mb-2 pa-1 lighten-4 rounded"
                          >
                            <div
                              class="d-flex justify-space-between align-center"
                            >
                              <div
                                v-if="protocol.clienteNome"
                                class="text-truncate font-weight-medium"
                              >
                                <v-icon x-small color="primary" class="mr-1"
                                  >mdi-account</v-icon
                                >
                                {{ protocol.clienteNome }}
                              </div>
                              <div
                                v-if="protocol.clienteId"
                                class="caption grey--text text--darken-1"
                              >
                                ID: {{ protocol.clienteId }}
                              </div>
                            </div>
                          </div>

                          <v-list-item-subtitle class="mt-0">
                            <div>
                              <div class="mb-1">
                                <strong>Protocolo:</strong>
                                {{ protocol.protocolo }}
                              </div>

                              <div class="mb-1">
                                <strong>Status:</strong>
                                <!-- Indicador de Participante -->
                                <v-chip
                                  v-if="protocol.visitante === loggedUserName"
                                  x-small
                                  color="#F2C94C"
                                  text-color="black"
                                  class="ml-1"
                                >
                                  Participando
                                </v-chip>
                                <v-chip
                                  v-else-if="
                                    protocol.emAtendimento &&
                                    protocol.status === 'open'
                                  "
                                  x-small
                                  color="info"
                                  class="ml-1"
                                >
                                  Em Atendimento
                                </v-chip>
                                <v-chip
                                  v-else
                                  x-small
                                  :color="
                                    protocol.status === 'open'
                                      ? 'success'
                                      : 'grey'
                                  "
                                  class="ml-1"
                                >
                                  {{
                                    protocol.status === "open"
                                      ? "Aberto"
                                      : "Fechado"
                                  }}
                                </v-chip>
                              </div>
                              <div class="caption">
                                <strong>Data de Abertura:</strong>
                                {{ formatDateBR(protocol.dataDeAbertura) }}
                                {{ protocol.horaDeAbertura }}
                              </div>
                              <div
                                v-if="protocol.numeroEmpresa"
                                class="caption"
                              >
                                <strong>Número da empresa:</strong>
                                {{ protocol.numeroEmpresa }}
                              </div>
                              <div
                                class="caption"
                                v-if="protocol.emAtendimento"
                              >
                                <strong>Atendente:</strong>
                                {{ protocol.emAtendimento }}
                              </div>

                              <div class="caption" v-if="protocol.visitante">
                                <strong>Participante:</strong>
                                {{ protocol.visitante }}
                              </div>
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item
                        v-if="filteredProtocols.length === 0"
                        class="px-3"
                      >
                        <v-list-item-content>
                          <v-list-item-subtitle class="text-center py-4">
                            {{
                              protocolSearch
                                ? "Nenhum protocolo encontrado com o filtro aplicado"
                                : "Nenhum protocolo encontrado"
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </div>
                </div>
              </v-card>
            </v-col>

            <!-- Coluna Direita: Chat -->
            <v-col
              :cols="12"
              md="8"
              v-show="!isMobile || currentProtocol"
              class="chat-panel"
            >
              <!-- Chat vazio quando não há protocolo selecionado -->
              <v-card
                v-if="!currentProtocol"
                outlined
                class="d-flex align-center justify-center"
                style="height: calc(100vh - 200px)"
              >
                <v-card-text class="text-center">
                  <v-icon size="64" color="grey lighten-1"
                    >mdi-chat-outline</v-icon
                  >
                  <div class="headline mt-4 grey--text">
                    Selecione um protocolo para visualizar o chat
                  </div>
                </v-card-text>
              </v-card>

              <!-- Chat History Section -->
              <v-card
                v-else
                outlined
                class="chat-card"
                style="
                  height: calc(100vh - 200px);
                  display: flex;
                  flex-direction: column;
                "
              >
                <!-- Título fixo no topo -->
                <div
                  class="pa-2"
                  style="
                    flex-shrink: 0;
                    border-bottom: 1px solid #e0e0e0;
                    background-color: white;
                  "
                >
                  <v-row>
                    <!-- Informações do protocolo -->
                    <v-col
                      cols="12"
                      sm="6"
                      class="d-flex align-center flex-wrap protocol-header-info"
                    >
                      <v-btn
                        v-if="isMobile"
                        icon
                        small
                        class="mr-2"
                        @click="voltarParaListaProtocolos"
                        title="Voltar para lista de protocolos"
                      >
                        <v-icon size="20">mdi-arrow-left</v-icon>
                      </v-btn>
                      <v-chip small class="mr-2">
                        <v-icon left x-small>mdi-identifier</v-icon>
                        Protocolo: {{ currentProtocol }}
                      </v-chip>
                      <v-chip
                        v-if="selectedProtocolData"
                        small
                        color="info"
                        text-color="white"
                      >
                        <v-icon left x-small>mdi-phone</v-icon>
                        {{ selectedProtocolData.contato }} -
                        {{ selectedProtocolData.numeroDoContato }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="6"> </v-col>
                    <!-- Botões de ação -->
                    <v-col cols="12" class="d-flex align-center justify-end">
                      <!-- Atualizar -->
                      <v-btn
                        text
                        elevation="0"
                        class="mr-2"
                        @click="refreshMessages"
                        :loading="loadingMessages"
                        x-small
                        title="Atualizar mensagens"
                      >
                        <v-icon x-small>mdi-refresh</v-icon>
                      </v-btn>

                      <!-- Detalhes do Cliente -->
                      <v-btn
                        :color="showingClientDetails ? 'error' : 'info'"
                        :outlined="!showingClientDetails"
                        elevation="2"
                        class="mr-2"
                        @click="toggleClientDetails"
                        :disabled="!currentProtocol"
                        x-small
                        :title="
                          showingClientDetails
                            ? 'Ocultar detalhes do cliente'
                            : 'Detalhes do cliente'
                        "
                      >
                        <v-icon left x-small>{{
                          showingClientDetails
                            ? "mdi-eye-off"
                            : "mdi-account-details"
                        }}</v-icon>
                        {{ showingClientDetails ? "Ocultar" : "Detalhes" }}
                      </v-btn>

                      <!-- Menu de Ações -->
                      <v-menu offset-y left>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            elevation="2"
                            v-bind="attrs"
                            v-on="on"
                            x-small
                          >
                            <v-icon left x-small>mdi-dots-vertical</v-icon>
                            Ações
                            <v-icon right x-small>mdi-menu-down</v-icon>
                          </v-btn>
                        </template>
                        <v-list dense>
                          <!-- Arquivos Enviados -->
                          <v-list-item
                            @click="showArquivosDialog = true"
                            :disabled="!currentProtocol"
                          >
                            <v-list-item-icon>
                              <v-icon small color="info">mdi-file-send</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                >Arquivos Enviados</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <!-- Transferir -->
                          <v-list-item
                            @click="abrirDialogTransferencia"
                            :disabled="transferringAttendance"
                          >
                            <v-list-item-icon>
                              <v-icon small color="warning"
                                >mdi-account-switch</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                >Transferir Atendimento</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>

                          <!-- Finalizar -->
                          <v-list-item
                            @click="confirmCloseProtocol"
                            :disabled="closingProtocol"
                          >
                            <v-list-item-icon>
                              <v-icon small color="error"
                                >mdi-close-circle</v-icon
                              >
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title
                                >Finalizar Protocolo</v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-col>
                  </v-row>
                </div>

                <!-- Área de mensagens (flexível) -->
                <div
                  style="
                    flex: 1;
                    overflow-y: auto;
                    overflow-x: hidden;
                    min-height: 0;
                    padding: 12px;
                  "
                >
                  <v-skeleton-loader
                    v-if="loadingMessages"
                    type="list-item-three-line"
                    :loading="loadingMessages"
                  ></v-skeleton-loader>

                  <div v-else class="chat-container">
                    <div
                      v-if="
                        selectedProtocolData &&
                        selectedProtocolData.numeroDoContato
                      "
                      class="d-flex justify-center align-center my-1 mb-3"
                    >
                      <v-btn
                        @click="toggleHistoricalMessages"
                        :color="
                          showingHistoricalMessages ? 'secondary' : 'primary'
                        "
                        outlined
                        :loading="loadingMessages"
                        :disabled="loadingMessages"
                        small
                      >
                        <v-icon left>{{
                          showingHistoricalMessages
                            ? "mdi-chevron-up"
                            : "mdi-history"
                        }}</v-icon>
                        {{
                          showingHistoricalMessages
                            ? "Ocultar Histórico"
                            : "Carregar Histórico Completo"
                        }}
                      </v-btn>
                    </div>
                    <!-- Seção de mensagens históricas -->
                    <template
                      v-if="
                        historicalMessages.length > 0 &&
                        showingHistoricalMessages
                      "
                    >
                      <div class="text-center my-4">
                        <v-chip small outlined color="primary" class="px-4">
                          --- Histórico de mensagens ({{
                            historicalMessages.length
                          }}) ---
                        </v-chip>
                      </div>

                      <div
                        v-for="message in historicalMessages"
                        :key="'hist-' + message._id"
                        :class="[
                          'message-bubble mb-2 pa-2',
                          message.message_type === 'note'
                            ? 'note-message-historico'
                            : message.direction === 'outgoing'
                            ? 'outgoing-message-historico'
                            : 'incoming-message-historico',
                        ]"
                      >
                        <div
                          v-if="message.message_type === 'error'"
                          class="error--text"
                        >
                          <v-alert type="error" dense text>
                            {{ stripHtml(message.message) }}
                          </v-alert>
                        </div>
                        <div v-else-if="message.message_type === 'note'">
                          {{ stripHtml(message.message) }}
                        </div>
                        <div
                          v-else-if="message.message_type === 'file'"
                          class="file-message"
                        >
                          <!-- Imagem -->
                          <div
                            v-if="isImage(message.fileUrl || message.message)"
                            class="text-center"
                          >
                            <v-img
                              :src="message.fileUrl || message.message"
                              max-height="300"
                              contain
                              class="rounded"
                              @click="
                                openMediaPreview(
                                  message.fileUrl || message.message,
                                )
                              "
                              style="cursor: pointer"
                            >
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="primary"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </div>

                          <!-- Áudio -->
                          <div
                            v-else-if="
                              isAudio(message.fileUrl || message.message)
                            "
                            class="text-center"
                          >
                            <audio
                              controls
                              preload="metadata"
                              style="max-width: 100%"
                            >
                              <source
                                :src="message.fileUrl || message.message"
                              />
                              Seu navegador não suporta a reprodução de áudios.
                            </audio>
                          </div>

                          <!-- Vídeo -->
                          <div
                            v-else-if="
                              isVideo(message.fileUrl || message.message)
                            "
                            class="text-center"
                          >
                            <video
                              controls
                              preload="metadata"
                              class="rounded"
                              style="max-width: 100%; max-height: 300px"
                            >
                              <source
                                :src="message.fileUrl || message.message"
                              />
                              Seu navegador não suporta a reprodução de vídeos.
                            </video>
                          </div>

                          <!-- Outros arquivos (download) -->
                          <div v-else class="text-center media-container">
                            <v-icon class="media-icon mb-2" color="primary"
                              >mdi-file-document-outline</v-icon
                            >
                            <v-btn
                              small
                              outlined
                              color="primary"
                              :href="message.fileUrl || message.message"
                              target="_blank"
                            >
                              <v-icon left small>mdi-open-in-new</v-icon>
                              Abrir arquivo
                            </v-btn>
                          </div>
                        </div>
                        <div v-else>
                          {{ message.message }}
                        </div>
                        <div class="caption text-right">
                          {{ formatDate(message.createdAt) }}
                          <template
                            v-if="
                              message.direction === 'outgoing' &&
                              message.userInsert
                            "
                          >
                            <br />
                            <span class="font-italic"
                              >Enviado por: {{ message.userInsert }}</span
                            >
                          </template>
                        </div>
                        <!-- Status de leitura (apenas para mensagens enviadas) -->
                        <div
                          v-if="
                            message.direction === 'outgoing' &&
                            message.ack !== undefined &&
                            message.ack !== null
                          "
                          class="caption text-right mt-1"
                          :class="{
                            'success--text': message.isRead === true,
                            'info--text':
                              message.isDelivered === true &&
                              message.isRead !== true,
                            'grey--text': !message.isDelivered,
                            'error--text': message.readStatus === 'error',
                          }"
                        >
                          <!-- Status de leitura igual ao das mensagens normais -->
                          <template v-if="message.isRead === true">
                            <v-icon x-small color="success">
                              mdi-check-all
                            </v-icon>
                            <span class="ml-1">Lido</span>
                          </template>
                          <template v-else-if="message.isDelivered === true">
                            <v-icon x-small color="info">
                              mdi-check-all
                            </v-icon>
                            <span class="ml-1">Entregue</span>
                          </template>
                          <template v-else-if="message.readStatus === 'error'">
                            <v-icon x-small color="error"
                              >mdi-alert-circle</v-icon
                            >
                            <span class="ml-1">Erro ao enviar</span>
                          </template>
                          <template v-else>
                            <v-icon x-small color="grey"> mdi-check </v-icon>
                            <span class="ml-1">Enviada</span>
                          </template>
                        </div>
                      </div>

                      <!-- Separador entre histórico e mensagens atuais -->
                      <div class="text-center my-4" v-if="messages.length > 0">
                        <v-chip small outlined color="success" class="px-4">
                          --- Mensagens atuais ---
                        </v-chip>
                      </div>
                    </template>

                    <!-- Mensagens atuais do protocolo -->
                    <div
                      v-for="message in messages"
                      :key="message._id"
                      :class="[
                        'message-bubble mb-2 pa-2',
                        message.message_type === 'note'
                          ? 'note-message'
                          : message.direction === 'outgoing'
                          ? 'outgoing-message'
                          : 'incoming-message',
                      ]"
                    >
                      <div
                        v-if="message.message_type === 'error'"
                        class="error--text"
                      >
                        <v-alert type="error" dense text>
                          {{ stripHtml(message.message) }}
                        </v-alert>
                      </div>
                      <div v-else-if="message.message_type === 'note'">
                        {{ stripHtml(message.message) }}
                      </div>
                      <div
                        v-else-if="message.message_type === 'file'"
                        class="file-message"
                      >
                        <!-- Imagem -->
                        <div
                          v-if="isImage(message.fileUrl || message.message)"
                          class="text-center"
                        >
                          <v-img
                            :src="message.fileUrl || message.message"
                            max-height="300"
                            contain
                            class="rounded"
                            @click="
                              openMediaPreview(
                                message.fileUrl || message.message,
                              )
                            "
                            style="cursor: pointer"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="primary"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </div>

                        <!-- Áudio -->
                        <div
                          v-else-if="
                            isAudio(message.fileUrl || message.message)
                          "
                          class="text-center"
                        >
                          <audio
                            controls
                            preload="metadata"
                            style="max-width: 100%"
                          >
                            <source :src="message.fileUrl || message.message" />
                            Seu navegador não suporta a reprodução de áudios.
                          </audio>
                        </div>

                        <!-- Vídeo -->
                        <div
                          v-else-if="
                            isVideo(message.fileUrl || message.message)
                          "
                          class="text-center"
                        >
                          <video
                            controls
                            preload="metadata"
                            class="rounded"
                            style="max-width: 100%; max-height: 300px"
                          >
                            <source :src="message.fileUrl || message.message" />
                            Seu navegador não suporta a reprodução de vídeos.
                          </video>
                        </div>

                        <!-- Outros arquivos (download) -->
                        <div v-else class="text-center media-container">
                          <v-icon class="media-icon mb-2" color="primary"
                            >mdi-file-document-outline</v-icon
                          >
                          <v-btn
                            small
                            outlined
                            color="primary"
                            :href="message.fileUrl || message.message"
                            target="_blank"
                          >
                            <v-icon left small>mdi-open-in-new</v-icon>
                            Abrir arquivo
                          </v-btn>
                        </div>
                      </div>
                      <div v-else>
                        {{ message.message }}
                      </div>
                      <div class="caption text-right">
                        {{ formatDate(message.createdAt) }}
                        <template
                          v-if="
                            message.direction === 'outgoing' &&
                            message.userInsert
                          "
                        >
                          <br />
                          <span class="font-italic"
                            >Enviado por: {{ message.userInsert }}</span
                          >
                        </template>
                      </div>
                      <!-- Status de leitura (apenas para mensagens enviadas) -->
                      <div
                        v-if="
                          message.direction === 'outgoing' &&
                          message.ack !== undefined &&
                          message.ack !== null
                        "
                        class="caption text-right mt-1"
                        :class="{
                          'success--text': message.isRead === true,
                          'info--text':
                            message.isDelivered === true &&
                            message.isRead !== true,
                          'grey--text': !message.isDelivered,
                          'error--text': message.readStatus === 'error',
                        }"
                      >
                        <template v-if="message.message_type === 'note'">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="on"
                                style="cursor: pointer"
                              >
                                <template
                                  v-if="message.message_type === 'note'"
                                >
                                  <v-icon x-small color="warning"
                                    >mdi-robot</v-icon
                                  >
                                  <span
                                    v-if="message.readAt"
                                    class="ml-1 caption"
                                  >
                                    {{ formatDate(message.readAt) }}
                                  </span>
                                </template>
                              </span>
                            </template>

                            <span>
                              Esta é uma informação privada e exibida apenas
                              para consulta interna.
                            </span>
                          </v-tooltip>
                        </template>

                        <!-- Lido (ACK 3) -->
                        <template v-else-if="message.isRead === true">
                          <v-icon x-small color="success">
                            mdi-check-all
                          </v-icon>
                          <span class="ml-1">Lido</span>
                          <span v-if="message.readAt" class="ml-1 caption">
                            {{ formatDate(message.readAt) }}
                          </span>
                        </template>
                        <!-- Entregue (ACK 2) -->
                        <template v-else-if="message.isDelivered === true">
                          <v-icon x-small color="info"> mdi-check-all </v-icon>
                          <span class="ml-1">Entregue</span>
                          <span v-if="message.deliveredAt" class="ml-1 caption">
                            {{ formatDate(message.deliveredAt) }}
                          </span>
                        </template>
                        <!-- Erro (ACK -2) -->
                        <template v-else-if="message.readStatus === 'error'">
                          <v-icon x-small color="error">
                            mdi-alert-circle
                          </v-icon>
                          <span class="ml-1">Erro ao enviar</span>
                        </template>
                        <!-- Enviada (ACK 0 ou 3) -->
                        <template v-else>
                          <v-icon x-small color="grey"> mdi-check </v-icon>
                          <span class="ml-1">Enviada</span>
                        </template>
                      </div>
                    </div>

                    <div v-if="messages.length === 0" class="text-center pa-4">
                      Nenhuma mensagem encontrada
                    </div>
                    <div ref="chatBottomAnchor" class="chat-bottom-anchor"></div>
                  </div>
                </div>

                <!-- Campo de envio fixo na parte inferior -->
                <div
                  class="pa-2"
                  style="
                    flex-shrink: 0;
                    border-top: 1px solid #e0e0e0;
                    background-color: white;
                  "
                >
                  <div class="text-formatting-buttons mb-1 d-flex align-center">
                    <v-btn-toggle
                      dense
                      group
                      class="elevation-0 rounded-lg mr-2"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            text
                            @click="formatar('bold')"
                            v-on="on"
                            class="px-1"
                          >
                            <v-icon small>mdi-format-bold</v-icon>
                          </v-btn>
                        </template>
                        <span>Negrito</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            text
                            @click="formatar('italic')"
                            v-on="on"
                            class="px-1"
                          >
                            <v-icon small>mdi-format-italic</v-icon>
                          </v-btn>
                        </template>
                        <span>Itálico</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            small
                            text
                            @click="formatar('underline')"
                            v-on="on"
                            class="px-1"
                          >
                            <v-icon small>mdi-format-underline</v-icon>
                          </v-btn>
                        </template>
                        <span>Sublinhado</span>
                      </v-tooltip>
                    </v-btn-toggle>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          text
                          @click="toggleEmojiPicker($event)"
                          v-on="on"
                          class="px-1"
                        >
                          <v-icon small>mdi-emoticon-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Inserir emoji</span>
                    </v-tooltip>
                  </div>

                  <!-- Emoji Picker -->
                  <div
                    v-if="showEmojiPicker"
                    class="emoji-picker-container"
                    :style="{
                      top: emojiPickerPosition.y + 'px',
                      left: emojiPickerPosition.x + 'px',
                    }"
                  >
                    <emoji-picker
                      @emoji-click="onEmojiClick"
                      class="light"
                    ></emoji-picker>
                  </div>
                  <div class="d-flex align-center message-input-area">
                    <v-textarea
                      ref="textareaRef"
                      v-model="freeTextMessage"
                      label="Digite sua mensagem"
                      rows="2"
                      hide-details
                      outlined
                      dense
                      auto-grow
                      style="flex: 1; max-height: 120px; overflow-y: auto"
                    ></v-textarea>
                    <v-btn
                      color="primary"
                      :loading="sendingMessage"
                      @click="sendFreeTextMessage"
                      class="ml-2"
                      small
                    >
                      Enviar
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
            <v-col v-if="showingClientDetails" cols="12" md="4">
              <v-card
                outlined
                class="client-details-card"
                style="height: calc(100vh - 200px); overflow-y: auto"
              >
                <!-- Cabeçalho do card -->
                <v-card-title>
                  <v-icon left color="primary">mdi-account-details</v-icon>
                  Detalhes do Cliente
                </v-card-title>

                <!-- Conteúdo principal do card -->
                <v-card-text>
                  <!-- Loading -->
                  <div v-if="loadingClientInfo" class="text-center py-5">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                    <div class="mt-3">Carregando informações do cliente...</div>
                  </div>

                  <!-- Erro -->
                  <div
                    v-else-if="clientInfoError"
                    class="text-center py-5 pt-12"
                  >
                    <v-alert type="error" outlined>
                      {{ clientInfoError }}
                    </v-alert>
                    <v-btn
                      color="primary"
                      @click="fetchClientInfo"
                      class="mt-3"
                    >
                      <v-icon left>mdi-refresh</v-icon>
                      Tentar novamente
                    </v-btn>
                  </div>

                  <!-- Sem dados -->
                  <div v-else-if="!clientInfo" class="text-center py-5">
                    <v-alert type="info" outlined>
                      Nenhuma informação disponível para este cliente.
                    </v-alert>
                  </div>

                  <!-- Dados do cliente -->
                  <div v-else class="mt-12">
                    <!-- Seletor de cliente -->
                    <div v-if="clientsCount > 1" class="mb-4">
                      <div class="d-flex align-center mb-2">
                        <v-chip color="primary" small class="mr-2">
                          {{ clientsCount }} clientes encontrados
                        </v-chip>
                        <div class="caption">
                          Selecione um cliente para visualizar os detalhes
                        </div>
                      </div>
                      <v-select
                        v-model="selectedClientIndex"
                        :items="
                          clients.map((client, index) => ({
                            text: client.nome || `Cliente ${index + 1}`,
                            value: index,
                          }))
                        "
                        label="Selecione o cliente"
                        outlined
                        dense
                        @change="changeSelectedClient"
                        class="mb-2"
                        color="primary"
                        item-color="primary"
                        hide-details
                      ></v-select>
                    </div>

                    <!-- Informações básicas -->
                    <div class="mb-4">
                      <v-list-item>
                        <v-list-item-avatar
                          size="60"
                          color="primary"
                          class="white--text"
                        >
                          {{
                            clientInfo.nome
                              ? clientInfo.nome.charAt(0).toUpperCase()
                              : "?"
                          }}
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="headline mb-1">{{
                            clientInfo.nome || "Nome não informado"
                          }}</v-list-item-title>
                          <v-list-item-subtitle>
                            <div>
                              <strong>CPF:</strong>
                              {{ formatCpf(clientInfo.cpf) || "Não informado" }}
                            </div>
                            <div>
                              <strong>Idade:</strong>
                              {{ clientInfo.idade || "Não informada" }} anos
                            </div>
                            <div class="caption">
                              <strong>ID do Cliente:</strong>
                              {{
                                clientInfo.idCliente ||
                                clientInfo.Id ||
                                "Não informado"
                              }}
                            </div>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>

                      <v-divider class="my-3"></v-divider>

                      <!-- Status do cliente -->
                      <div
                        class="d-flex align-center mb-3"
                        v-if="clientInfo.dataFalecimento"
                      >
                        <div class="subtitle-1 font-weight-medium">Status:</div>
                        <v-chip
                          :color="
                            clientInfo.dataFalecimento ? 'error' : 'success'
                          "
                          small
                          class="ml-2"
                          :text-color="
                            clientInfo.dataFalecimento ? 'white' : ''
                          "
                        >
                          {{
                            clientInfo.dataFalecimento ? "Falecido" : "Ativo"
                          }}
                        </v-chip>
                        <div
                          v-if="clientInfo.dataFalecimento"
                          class="ml-2 caption"
                        >
                          Data: {{ formatDate(clientInfo.dataFalecimento) }}
                        </div>
                      </div>

                      <!-- Contratos -->
                      <div class="pt-0 subtitle-1 font-weight-medium">
                        Contratos ({{
                          clientInfo.contratos
                            ? clientInfo.contratos.length
                            : 0
                        }})
                      </div>
                    </div>

                    <!-- Lista de contratos -->
                    <div class="pt-0">
                      <v-expansion-panels>
                        <v-expansion-panel
                          v-for="contrato in clientInfo.contratos"
                          :key="contrato.id"
                          class="expansion-panel"
                        >
                          <v-expansion-panel-header>
                            <div>
                              <div class="font-weight-medium">
                                {{ contrato.tipo }}
                              </div>
                              <div class="caption">
                                <v-chip
                                  x-small
                                  :color="
                                    contrato.status === 'Ativo'
                                      ? 'success'
                                      : 'grey'
                                  "
                                  class="mr-1"
                                >
                                  {{ contrato.status }}
                                </v-chip>
                                Ref: {{ contrato.referencia }}
                              </div>
                            </div>
                          </v-expansion-panel-header>

                          <v-expansion-panel-content expand>
                            <v-divider></v-divider>

                            <!-- Detalhes simples -->
                            <div class="py-3">
                              <div>
                                <strong>Empresa:</strong> {{ contrato.empresa }}
                              </div>
                              <div>
                                <strong>Data:</strong>
                                {{ formatDate(contrato.dataContrato) }}
                              </div>

                              <!-- Informações de LTV -->
                              <div v-if="contrato.ltv" class="mt-4">
                                <v-divider class="my-1"></v-divider>
                                <div class="subtitle-2 mb-1">
                                  Informações de LTV
                                </div>

                                <v-row dense class="py-2">
                                  <v-col cols="12" sm="6" class="py-0">
                                    <div class="caption">
                                      <strong>Severidade:</strong>
                                      {{ contrato.ltv.severidade }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" sm="6" class="py-0">
                                    <div class="caption">
                                      <strong>LTV:</strong>
                                      {{ contrato.ltv.ltv.toFixed(4) }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" sm="6" class="py-0">
                                    <div class="caption">
                                      <strong>Débito Cliente:</strong> R$
                                      {{
                                        contrato.ltv.debitoCliente.toFixed(2)
                                      }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" sm="6" class="py-0">
                                    <div class="caption">
                                      <strong>% Aplicado:</strong>
                                      {{ contrato.ltv.percentualAplicado }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" sm="6" class="py-0">
                                    <div class="caption">
                                      <strong>Desconto:</strong> R$
                                      {{ contrato.ltv.desconto.toFixed(2) }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" sm="6" class="py-0">
                                    <div class="caption">
                                      <strong>Valor Final:</strong> R$
                                      {{ contrato.ltv.valorFinal.toFixed(2) }}
                                    </div>
                                  </v-col>
                                  <v-col cols="12" class="py-0">
                                    <div class="caption">
                                      <strong>Oferta:</strong>
                                      {{ contrato.ltv.oferta }}
                                    </div>
                                  </v-col>
                                </v-row>
                              </div>
                            </div>

                            <v-divider></v-divider>

                            <!-- Parcelas -->
                            <!-- Sistema de abas para parcelas e interações -->
                            <v-tabs
                              v-model="activeTab"
                              background-color="transparent"
                              color="primary"
                              grow
                              class="mt-3"
                            >
                              <v-tab>
                                <v-icon left small>mdi-cash-multiple</v-icon>
                                Parcelas
                              </v-tab>
                              <v-tab>
                                <v-icon left small>mdi-history</v-icon>
                                Interações
                              </v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="activeTab">
                              <v-tab-item>
                                <!-- Parcelas -->
                                <div class="pa-0 pt-4">
                                  <div
                                    v-if="!contrato.parcelas?.length"
                                    class="caption text-center pa-4"
                                  >
                                    <v-icon large color="grey lighten-1"
                                      >mdi-cash-remove</v-icon
                                    >
                                    <div class="mt-2">
                                      Nenhuma parcela encontrada
                                    </div>
                                  </div>

                                  <v-data-table
                                    v-else
                                    :headers="[]"
                                    :items="contrato.parcelas"
                                    hide-default-header
                                    :items-per-page="5"
                                    class="elevation-0 mt-2"
                                    :footer-props="{
                                      'items-per-page-options': [5, 10, 15],
                                      'show-current-page': true,
                                      'show-first-last-page': true,
                                      'items-per-page-text':
                                        'Itens por página:',
                                    }"
                                  >
                                    <template v-slot:item="{ item: parcela }">
                                      <tr>
                                        <td>
                                          <div class="py-2 border-bottom">
                                            <div
                                              class="caption d-flex justify-space-between"
                                            >
                                              <div class="subtitle-2">
                                                {{
                                                  formatDateBR(
                                                    parcela.vencimento,
                                                  )
                                                }}
                                              </div>
                                              <v-chip
                                                small
                                                :color="
                                                  getVencimentoColor(
                                                    parcela.vencimento,
                                                    parcela.status,
                                                  )
                                                "
                                                :text-color="
                                                  getVencimentoColor(
                                                    parcela.vencimento,
                                                    parcela.status,
                                                  ) === 'error'
                                                    ? 'white'
                                                    : ''
                                                "
                                              >
                                                {{
                                                  getVencimentoStatus(
                                                    parcela.vencimento,
                                                    parcela.status,
                                                  )
                                                }}
                                              </v-chip>
                                            </div>
                                            <div
                                              class="caption d-flex justify-space-between align-center mt-2"
                                            >
                                              <div class="d-flex align-center">
                                                <div class="caption">
                                                  Identificação:
                                                  {{ parcela.identificacao }}
                                                </div>
                                                <v-btn
                                                  v-if="parcela.idDocumento"
                                                  x-small
                                                  color="primary"
                                                  class="ml-2"
                                                  @click="
                                                    abrirDialogSelecaoFormaPagamento(
                                                      parcela.idDocumento,
                                                    )
                                                  "
                                                  :loading="
                                                    loadingFormaPagamento ===
                                                    parcela.idDocumento
                                                  "
                                                  title="Pagar"
                                                  :disabled="
                                                    !isCurrentUserAttendant &&
                                                    !isCurrentUserParticipant
                                                  "
                                                >
                                                  <v-icon left small
                                                    >mdi-credit-card</v-icon
                                                  >
                                                  Pagar
                                                </v-btn>
                                              </div>

                                              <div class="subtitle-2">
                                                R$
                                                {{
                                                  parcela.valor
                                                    .toFixed(2)
                                                    .replace(".", ",")
                                                }}
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </template>
                                  </v-data-table>
                                </div>
                              </v-tab-item>

                              <v-tab-item>
                                <!-- Interações -->
                                <div class="pa-0 pt-4">
                                  <div
                                    v-if="!contrato.interacoes?.length"
                                    class="caption text-center pa-4"
                                  >
                                    <v-icon large color="grey lighten-1"
                                      >mdi-message-text-outline</v-icon
                                    >
                                    <div class="mt-2">
                                      Nenhuma interação encontrada
                                    </div>
                                  </div>

                                  <v-data-table
                                    v-else
                                    :headers="[]"
                                    :items="contrato.interacoes"
                                    hide-default-header
                                    :items-per-page="5"
                                    class="elevation-0 mt-2"
                                    :footer-props="{
                                      'items-per-page-options': [5, 10, 15],
                                      'show-current-page': true,
                                      'show-first-last-page': true,
                                      'items-per-page-text':
                                        'Itens por página:',
                                    }"
                                  >
                                    <template v-slot:item="{ item: i }">
                                      <tr>
                                        <td>
                                          <div class="py-2 border-bottom">
                                            <div class="caption">
                                              {{ i.assunto }}
                                            </div>

                                            <div class="caption">
                                              {{ i.descricao }}
                                            </div>
                                            <div
                                              class="caption d-flex justify-space-between mt-2"
                                            >
                                              <v-chip small>{{
                                                i.contrato
                                              }}</v-chip>
                                              {{
                                                formatDateBR(i.dataInteracao)
                                              }}
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </template>
                                  </v-data-table>
                                </div>
                              </v-tab-item>
                            </v-tabs-items>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>

                      <v-divider class="my-3"></v-divider>
                      <v-expansion-panels>
                        <v-expansion-panel class="expansion-panel">
                          <v-expansion-panel-header>
                            <div class="pt-0 subtitle-1 font-weight-medium">
                              Protocolos ({{
                                clientInfo.protocolos
                                  ? clientInfo.protocolos.length
                                  : 0
                              }})
                            </div>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content expand>
                            <div class="pt-0">
                              <v-data-table
                                :headers="[]"
                                :items="clientInfo.protocolos"
                                hide-default-header
                                :items-per-page="5"
                                class="elevation-0 mt-2"
                                :footer-props="{
                                  'items-per-page-options': [5],
                                  'show-current-page': true,
                                  'show-first-last-page': true,
                                }"
                              >
                                <template v-slot:item="{ item: i }">
                                  <tr>
                                    <td>
                                      <div class="py-2 border-bottom">
                                        <div
                                          class="d-flex justify-space-between align-center"
                                        >
                                          <!-- Texto -->
                                          <div>
                                            <div class="text-body-2">
                                              Protocolo: {{ i.protocolNumber }}
                                            </div>

                                            <div class="caption">
                                              Responsável: {{ i.userInsert }}
                                            </div>
                                          </div>

                                          <!-- Botão -->
                                          <v-btn
                                            small
                                            text
                                            color="primary"
                                            @click="abrirProtocolo(i)"
                                          >
                                            <v-icon>mdi-eye</v-icon>
                                          </v-btn>
                                        </div>

                                        <div
                                          class="caption d-flex justify-space-between mt-2"
                                        >
                                          <v-chip
                                            small
                                            :color="
                                              i.status === 'closed'
                                                ? 'green'
                                                : 'warning'
                                            "
                                          >
                                            {{
                                              i.status === "closed"
                                                ? "Concluído"
                                                : "Aberto"
                                            }}
                                          </v-chip>

                                          {{ formatDate(i.dataCreate) }}
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                      <!-- Protocolos -->
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </base-material-card>
    </v-container>

    <!-- Diálogo de Confirmação para Fechar Protocolo -->
    <v-dialog
      v-model="showCloseProtocolConfirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Confirmar fechamento de protocolo
        </v-card-title>
        <v-card-text>
          Tem certeza que deseja fechar este protocolo?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelCloseProtocol">
            Cancelar
          </v-btn>
          <v-btn color="red darken-1" text @click="executeCloseProtocol">
            Fechar Protocolo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Confirmação para Remover Participante ou Sair do Atendimento -->
    <v-dialog
      v-model="showRemoveParticipantConfirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title
          class="headline"
          :class="
            isCurrentUserAttendant
              ? 'amber darken-2 white--text'
              : 'warning white--text'
          "
        >
          <v-icon color="white" class="mr-2">{{
            isCurrentUserAttendant ? "mdi-account-minus" : "mdi-exit-to-app"
          }}</v-icon>
          {{
            isCurrentUserAttendant
              ? "Confirmar remoção de participante"
              : "Confirmar saída do atendimento"
          }}
        </v-card-title>
        <v-card-text class="pt-4">
          {{
            isCurrentUserAttendant
              ? "Tem certeza que deseja remover o participante deste atendimento?"
              : "Tem certeza que deseja sair deste atendimento?"
          }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelRemoveParticipant">
            Cancelar
          </v-btn>
          <v-btn
            :color="isCurrentUserAttendant ? 'amber darken-3' : 'warning'"
            text
            @click="executeRemoveParticipant(isCurrentUserAttendant)"
          >
            {{
              isCurrentUserAttendant
                ? "Remover Participante"
                : "Sair do Atendimento"
            }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para transferência de atendimento -->
    <v-dialog
      v-model="showTransferDialog"
      max-width="1000"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon color="white" class="mr-2">mdi-account-switch</v-icon>
          Transferir Atendimento
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert type="info" outlined class="mb-6 px-2 py-1">
            Selecione um colaborador para transferir o atendimento do protocolo
            <strong>{{ currentProtocol }}</strong>
          </v-alert>

          <v-text-field
            v-model="searchColaborador"
            append-icon="mdi-magnify"
            label="Buscar colaborador"
            outlined
            dense
            clearable
            class="mb-3"
          ></v-text-field>

          <v-data-table
            :headers="colaboradoresHeaders"
            :items="colaboradores"
            :search="searchColaborador"
            :loading="loadingColaboradores"
            item-key="id"
            single-select
            show-select
            v-model="selectedColaboradores"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-options': [5, 10, 15],
              'items-per-page-text': 'Itens por página:',
              'show-current-page': true,
            }"
            class="elevation-0 rounded"
            :no-data-text="
              loadingColaboradores
                ? 'Carregando colaboradores...'
                : 'Nenhum colaborador encontrado'
            "
          ></v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="
              showTransferDialog = false;
              selectedColaboradores = [];
              transferringAttendance = false;
              searchColaborador = '';
            "
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="executarTransferencia"
            :disabled="!selectedColaboradores.length || transferringAttendance"
            :loading="transferringAttendance"
          >
            <v-icon left small>mdi-check</v-icon>
            Transferir Atendimento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de pré-visualização de mídia -->
    <v-dialog v-model="mediaPreviewDialog" max-width="90vw" max-height="90vh">
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon color="white" class="mr-2">{{
            mediaPreviewType === "image"
              ? "mdi-image"
              : mediaPreviewType === "video"
              ? "mdi-video"
              : mediaPreviewType === "audio"
              ? "mdi-music"
              : "mdi-file"
          }}</v-icon>
          Visualização de
          {{
            mediaPreviewType === "image"
              ? "Imagem"
              : mediaPreviewType === "video"
              ? "Vídeo"
              : mediaPreviewType === "audio"
              ? "Áudio"
              : "Arquivo"
          }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="mediaPreviewDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-4 text-center">
          <!-- Imagem -->
          <div v-if="mediaPreviewType === 'image'" class="text-center">
            <v-img
              :src="mediaPreviewUrl"
              max-height="80vh"
              contain
              class="rounded"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </div>

          <!-- Vídeo -->
          <div v-else-if="mediaPreviewType === 'video'" class="text-center">
            <video
              controls
              autoplay
              class="rounded"
              style="max-width: 100%; max-height: 80vh"
            >
              <source :src="mediaPreviewUrl" />
              Seu navegador não suporta a reprodução de vídeos.
            </video>
          </div>

          <!-- Áudio -->
          <div v-else-if="mediaPreviewType === 'audio'" class="text-center">
            <audio controls autoplay class="w-100 mt-8">
              <source :src="mediaPreviewUrl" />
              Seu navegador não suporta a reprodução de áudios.
            </audio>
          </div>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :href="mediaPreviewUrl"
            target="_blank"
            download
          >
            <v-icon left>mdi-download</v-icon>
            Baixar
          </v-btn>
          <v-btn color="grey darken-1" text @click="mediaPreviewDialog = false">
            <v-icon left>mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para adicionar participante -->
    <v-dialog
      v-model="showParticipantDialog"
      max-width="1000"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline success white--text">
          <v-icon color="white" class="mr-2">mdi-account-plus</v-icon>
          Adicionar Participante
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert type="info" outlined class="mb-6 px-2 py-1">
            Selecione um colaborador para adicionar como participante no
            protocolo
            <strong>{{ currentProtocol }}</strong>
          </v-alert>

          <v-text-field
            v-model="searchColaborador"
            append-icon="mdi-magnify"
            label="Buscar colaborador"
            outlined
            dense
            clearable
            class="mb-3"
          ></v-text-field>

          <v-data-table
            :headers="colaboradoresHeaders"
            :items="colaboradores"
            :search="searchColaborador"
            :loading="loadingColaboradores"
            item-key="id"
            single-select
            show-select
            v-model="selectedColaboradores"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-options': [5, 10, 15],
              'items-per-page-text': 'Itens por página:',
              'show-current-page': true,
            }"
            class="elevation-0 rounded"
            :no-data-text="
              loadingColaboradores
                ? 'Carregando colaboradores...'
                : 'Nenhum colaborador encontrado'
            "
          ></v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="
              showParticipantDialog = false;
              selectedColaboradores = [];
              addingParticipant = false;
              searchColaborador = '';
            "
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="adicionarParticipante"
            :disabled="!selectedColaboradores.length || addingParticipant"
            :loading="addingParticipant"
          >
            <v-icon left small>mdi-check</v-icon>
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Seleção de Forma de Pagamento -->
    <v-dialog
      v-model="showSelecaoFormaPagamentoDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-overlay :value="loadingFormaPagamento !== null" absolute>
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
          ></v-progress-circular>
          <div class="mt-4 white--text">Processando...</div>
        </v-overlay>
        <v-card-title class="headline primary white--text">
          <v-icon color="white" class="mr-2">mdi-credit-card</v-icon>
          Selecionar Forma de Pagamento
        </v-card-title>
        <v-card-text class="pt-4">
          <p class="body-1 mb-4">Escolha a forma de pagamento desejada:</p>
          <v-list>
            <v-list-item
              class="mb-2"
              :disabled="loadingFormaPagamento !== null"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
              @click="selecionarFormaPagamento('PDF')"
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-file-document</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>PDF Boleto</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="selecionarFormaPagamento('Pix')"
              :disabled="loadingFormaPagamento !== null"
              class="mb-2"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-qrcode</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Pix</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="selecionarFormaPagamento('Link de Pagamento')"
              :disabled="loadingFormaPagamento !== null"
              class="mb-2"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-link</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Link de Pagamento</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="selecionarFormaPagamento('Código de Barras')"
              :disabled="loadingFormaPagamento !== null"
              class="mb-2"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-barcode</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Código de Barras</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            @click="closeSelecaoFormaPagamentoDialog"
            :disabled="loadingFormaPagamento !== null"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Forma de Pagamento -->
    <v-dialog
      v-model="showFormaPagamentoDialog"
      max-width="800"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon color="white" class="mr-2">mdi-credit-card</v-icon>
          Forma de Pagamento
        </v-card-title>
        <v-card-text class="pt-4">
          <!-- Mensagem de erro -->
          <p v-if="formaPagamentoResponse" class="body-1">
            {{ formaPagamentoResponse }}
          </p>

          <!-- Link da forma de pagamento -->
          <div v-if="formaPagamentoLink">
            <p class="body-2 mb-2">Link gerado:</p>
            <v-text-field
              :value="formaPagamentoLink"
              readonly
              outlined
              dense
              class="mb-3"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- Botões quando houver link -->
          <template v-if="formaPagamentoLink">
            <v-btn
              color="success"
              @click="enviarMensagemFormaPagamento"
              :loading="sendingMessage"
              class="mr-2"
            >
              <v-icon left small>mdi-send</v-icon>
              Enviar Mensagem
            </v-btn>
            <v-btn color="info" @click="copiarLinkFormaPagamento" class="mr-2">
              <v-icon left small>mdi-content-copy</v-icon>
              Copiar
            </v-btn>
          </template>
          <!-- Botão copiar quando houver apenas mensagem (exceto mensagem de erro de forma não habilitada) -->
          <template
            v-else-if="
              formaPagamentoResponse &&
              formaPagamentoResponse !==
                'Esta forma de pagamento não está habilitada para este documento.'
            "
          >
            <v-btn color="info" @click="copiarTextoFormaPagamento" class="mr-2">
              <v-icon left small>mdi-content-copy</v-icon>
              Copiar
            </v-btn>
            <v-btn
              color="success"
              @click="enviarMensagemTextoFormaPagamento"
              :loading="sendingMessage"
              class="mr-2"
            >
              <v-icon left small>mdi-send</v-icon>
              Enviar Mensagem
            </v-btn>
          </template>
          <v-btn color="primary" @click="closeFormaPagamentoDialog">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Arquivos Enviados -->
    <v-dialog
      v-model="showArquivosDialog"
      max-width="1200"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon color="white" class="mr-2">mdi-file-send</v-icon>
          Arquivos Enviados
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showArquivosDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-data-table
            :headers="arquivosHeaders"
            :items="arquivosProtocolo"
            :loading="loadingArquivos"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [5, 10, 15],
              'items-per-page-text': 'Itens por página:',
              'show-current-page': true,
            }"
            class="elevation-0 rounded"
            :no-data-text="
              loadingArquivos
                ? 'Carregando arquivos...'
                : 'Nenhum arquivo encontrado'
            "
          >
            <!-- Coluna de data -->
            <template v-slot:item.dataCreate="{ item }">
              {{ formatDate(item.dataCreate) }}
            </template>

            <!-- Coluna de URL -->
            <template v-slot:item.url="{ item }">
              <div class="url-container">
                <span
                  class="url-text text-truncate"
                  style="max-width: 200px; display: inline-block"
                >
                  {{ item.url }}
                </span>
              </div>
            </template>

            <!-- Coluna de ações -->
            <template v-slot:item.actions="{ item }">
              <v-btn
                small
                flat
                color="info"
                @click="copiarUrl(item.url)"
                title="Copiar URL"
              >
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="showArquivosDialog = false">
            <v-icon left small>mdi-close</v-icon>
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Minhas Interações -->
    <v-dialog
      v-model="showInteracoesDialog"
      max-width="1200"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline info white--text">
          <v-icon color="white" class="mr-2">mdi-history</v-icon>
          Minhas Interações
        </v-card-title>
        <v-card-text class="pt-4">
          <!-- Filtros -->
          <v-row dense>
            <v-col cols="12" sm="5">
              <span>Data Inicial</span>
              <v-menu
                v-model="menuDataInicio"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="filtroDataInicioFormatada"
                    label="Data Inicial"
                    dense
                    solo-inverted
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="filtroDataInicio"
                  @input="menuDataInicio = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="5">
              <span>Data Final</span>
              <v-menu
                v-model="menuDataFim"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template #activator="{ on }">
                  <v-text-field
                    v-model="filtroDataFimFormatada"
                    label="Data Final"
                    dense
                    solo-inverted
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="filtroDataFim"
                  @input="menuDataFim = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="2" class="d-flex align-center">
              <v-btn
                color="primary"
                @click="buscarInteracoes"
                :loading="loadingInteracoes"
                class="mt-1"
                small
              >
                <v-icon left>mdi-magnify</v-icon>
                Buscar
              </v-btn>
            </v-col>
          </v-row>

          <!-- Tabela de Interações -->
          <v-data-table
            :headers="interacoesHeaders"
            :items="interacoes"
            :loading="loadingInteracoes"
            :search="searchInteracoes"
            :items-per-page="10"
            :footer-props="{
              'items-per-page-options': [5, 10, 15, 20],
              'items-per-page-text': 'Itens por página:',
              'show-current-page': true,
            }"
            class="elevation-0 mt-4"
          >
            <template v-slot:top>
              <v-text-field
                v-model="searchInteracoes"
                label="Buscar"
                prepend-icon="mdi-magnify"
                class="mx-4 mt-4"
                dense
                outlined
                hide-details
                clearable
              ></v-text-field>
            </template>
            <template v-slot:item.dtInteracao="{ item }">
              {{ formatDateBR(item.dtInteracao) }}
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                :color="getStatusColor(item.status)"
                small
                label
                text-color="white"
              >
                {{ item.status }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn
                x-small
                color="primary"
                @click="selecionarTelefone(item.telefone)"
                title="Selecionar este telefone"
              >
                <v-icon x-small>mdi-check</v-icon>
                Selecionar
              </v-btn>
            </template>
            <template v-slot:no-data>
              {{
                loadingInteracoes
                  ? "Carregando interações..."
                  : "Nenhuma interação encontrada"
              }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeInteracoesDialog">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog para visualizar mensagens do protocolo -->
    <v-dialog v-model="showProtocolMessagesDialog" max-width="800" scrollable>
      <v-card>
        <v-card-title class="headline primary white--text">
          Mensagens do Protocolo
          {{ protocolMessagesData ? protocolMessagesData.protocolNumber : "" }}
        </v-card-title>

        <v-card-text class="pt-4" style="height: 500px">
          <!-- Loading -->
          <div v-if="protocolMessagesLoading" class="text-center py-5">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <div class="mt-3">Carregando mensagens...</div>
          </div>

          <!-- Sem mensagens -->
          <div
            v-else-if="selectedProtocolMessages.length === 0"
            class="text-center py-5"
          >
            <v-alert type="info" outlined>
              Nenhuma mensagem encontrada para este protocolo.
            </v-alert>
          </div>

          <!-- Mensagens -->
          <div v-else class="chat-container">
            <!-- Mensagens do protocolo -->
            <div
              v-for="message in selectedProtocolMessages"
              :key="message._id"
              :class="[
                'message-bubble mb-2 pa-2',
                message.message_type === 'note'
                  ? 'note-message'
                  : message.direction === 'outgoing'
                  ? 'outgoing-message'
                  : 'incoming-message',
              ]"
            >
              <div v-if="message.message_type === 'error'" class="error--text">
                <v-alert type="error" dense text>
                  {{ stripHtml(message.message) }}
                </v-alert>
              </div>
              <div v-else-if="message.message_type === 'note'">
                {{ stripHtml(message.message) }}
              </div>
              <div
                v-else-if="message.message_type === 'file'"
                class="file-message"
              >
                <!-- Imagem -->
                <div
                  v-if="isImage(message.fileUrl || message.message)"
                  class="text-center"
                >
                  <v-img
                    :src="message.fileUrl || message.message"
                    max-height="300"
                    contain
                    class="rounded"
                    @click="
                      openMediaPreview(message.fileUrl || message.message)
                    "
                    style="cursor: pointer"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </div>

                <!-- Áudio -->
                <div
                  v-else-if="isAudio(message.fileUrl || message.message)"
                  class="text-center"
                >
                  <audio controls preload="metadata" style="max-width: 100%">
                    <source :src="message.fileUrl || message.message" />
                    Seu navegador não suporta a reprodução de áudios.
                  </audio>
                </div>

                <!-- Vídeo -->
                <div
                  v-else-if="isVideo(message.fileUrl || message.message)"
                  class="text-center"
                >
                  <video
                    controls
                    preload="metadata"
                    class="rounded"
                    style="max-width: 100%; max-height: 300px"
                  >
                    <source :src="message.fileUrl || message.message" />
                    Seu navegador não suporta a reprodução de vídeos.
                  </video>
                </div>

                <!-- Outros arquivos (download) -->
                <div v-else class="text-center media-container">
                  <v-icon class="media-icon mb-2" color="primary"
                    >mdi-file-document-outline</v-icon
                  >
                  <v-btn
                    small
                    outlined
                    color="primary"
                    :href="message.fileUrl || message.message"
                    target="_blank"
                  >
                    <v-icon left small>mdi-open-in-new</v-icon>
                    Abrir arquivo
                  </v-btn>
                </div>
              </div>
              <div v-else>
                {{ message.message }}
              </div>
              <div class="caption text-right">
                {{ formatDate(message.createdAt) }}
                <template
                  v-if="message.direction === 'outgoing' && message.userInsert"
                >
                  <br />
                  <span class="font-italic"
                    >Enviado por: {{ message.userInsert }}</span
                  >
                </template>
              </div>
              <!-- Status de leitura (apenas para mensagens enviadas) -->
              <div
                v-if="
                  message.direction === 'outgoing' &&
                  message.ack !== undefined &&
                  message.ack !== null
                "
                class="caption text-right mt-1"
                :class="{
                  'success--text': message.isRead === true,
                  'info--text':
                    message.isDelivered === true && message.isRead !== true,
                  'grey--text': !message.isDelivered,
                  'error--text': message.readStatus === 'error',
                }"
              >
                <template v-if="message.isRead === true">
                  <v-icon x-small color="success"> mdi-check-all </v-icon>
                  <span class="ml-1">Lido</span>
                </template>
                <template v-else-if="message.isDelivered === true">
                  <v-icon x-small color="info"> mdi-check-all </v-icon>
                  <span class="ml-1">Entregue</span>
                </template>
                <template v-else-if="message.readStatus === 'error'">
                  <v-icon x-small color="error">mdi-alert-circle</v-icon>
                  <span class="ml-1">Erro ao enviar</span>
                </template>
                <template v-else>
                  <v-icon x-small color="grey"> mdi-check </v-icon>
                  <span class="ml-1">Enviada</span>
                </template>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeProtocolMessagesDialog">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import SonaxService from "@/services/v2sonax";
import UsuarioService from "@/services/usuario";

// Carregamento do emoji-picker
let emojiPickerLoaded = false;

async function loadEmojiPicker() {
  if (!emojiPickerLoaded) {
    await import("emoji-picker-element");
    emojiPickerLoaded = true;
  }
}

export default {
  name: "Chat",

  data: () => ({
    // Propriedades para o diálogo de mensagens do protocolo
    showProtocolMessagesDialog: false,
    protocolMessagesData: null,
    selectedProtocolMessages: [],
    protocolMessagesLoading: false,

    // Filtros de data
    filtroDataInicio: "", // Data de início para filtro (formato ISO)
    filtroDataFim: "", // Data de fim para filtro (formato ISO)
    menuDataInicio: false, // Controla a exibição do date picker de data início
    menuDataFim: false, // Controla a exibição do date picker de data fim

    // Modal de pré-visualização de mídia
    mediaPreviewDialog: false,
    mediaPreviewUrl: null,
    mediaPreviewType: null,

    // Authentication
    isAuthenticated: false,
    authError: null,

    // Empresa
    selectedEmpresa: null,
    empresas: [
      "A FLOR DO CAFÉ",
      "CEMITERIO PREVIDA",
      "CEMITERIO PREVIDA SÃO MIGUEL",
      "MEMORIAL PARQUE MACEIÓ",
      "PARQUE DAS FLORES",
      "PARQUE DO AGRESTE",
      "PREVIDA",
    ],

    // Referência para o textarea
    textareaRef: null,

    // Emoji picker
    showEmojiPicker: false,
    emojiPickerPosition: { x: 0, y: 0 },

    // Templates
    loadingTemplates: false,
    templates: [], // Array de templates (não mais um objeto complexo)
    selectedTemplate: null,
    selectedTemplateId: null, // ID do template selecionado no select
    showTemplateContent: false, // Controla exibição do conteúdo do template

    // Message sending
    valid: true,
    phoneNumber: "",
    phoneRules: [
      (v) => !!v || "Número de telefone é obrigatório",
      (v) => /^\d{10,11}$/.test(v) || "Número de telefone inválido",
    ],
    templateParams: [],
    freeTextMessage: "",
    sendingMessage: false,

    // Message history
    currentProtocol: null,
    currentProtocolId: null, // ID do protocolo para fechar
    messages: [], // Mensagens atuais do protocolo
    historicalMessages: [], // Mensagens históricas de outros protocolos
    loadingMessages: false,
    closingProtocol: false,
    linkingAttendance: false, // Loading para vincular atendimento
    unlinkingAttendance: false, // Loading para desvincular atendimento
    messagePollingInterval: null, // Intervalo para consulta automática de mensagens

    // Protocolos
    openProtocols: [],
    totalProtocols: null,
    loadingProtocols: false,
    selectedFilas: [],
    filaOptions: [],
    loadingFilas: false,
    selectedProtocolData: null,
    showingHistoricalMessages: false, // Controla a exibição das mensagens históricas
    protocolSearch: "", // Campo de busca para filtrar protocolos
    protocolStatusFilter: "aberto", // Filtro de status: "open" ou "closed"
    statusFilterOptions: [
      {
        value: "todos",
        label: "Todos",
        icon: "mdi-filter-variant",
        color: "primary",
      },
      {
        value: "aberto",
        label: "Aberto",
        icon: "mdi-lock-open",
        color: "success",
      },
      {
        value: "em_atendimento",
        label: "Em atendimento",
        icon: "mdi-account-check",
        color: "info",
      },
      {
        value: "fechados",
        label: "Fechado",
        icon: "mdi-lock",
        color: "grey",
      },
    ],

    // Verificação de contato
    checkingContact: false,
    showProtocolDialog: false,
    contactInfo: null,

    // Diálogo de Fechar Protocolo
    showCloseProtocolConfirmDialog: false,

    // Diálogo de Remover Participante
    showRemoveParticipantConfirmDialog: false,

    // Diálogo de Sair do Atendimento
    showExitAttendanceConfirmDialog: false,

    // Diálogo de Novo Atendimento
    showNewAttendanceDialog: false,

    showingClientDetails: false, // Controla a exibição dos detalhes do cliente
    clientInfo: null, // Informações do cliente
    clientsData: [], // Lista de clientes encontrados
    selectedClientIndex: 0, // Índice do cliente selecionado
    loadingClientInfo: false, // Controla o estado de carregamento das informações do cliente
    clientInfoError: null, // Armazena erros na busca de informações do cliente
    expandedContracts: [], // Controla quais contratos estão expandidos
    activeTab: 0, // Controla qual aba está ativa (0 = Parcelas, 1 = Interações)

    // Forma de pagamento
    loadingFormaPagamento: null, // ID do documento sendo processado
    showFormaPagamentoDialog: false, // Controla exibição do diálogo
    formaPagamentoResponse: null, // Resposta da API de forma de pagamento (mensagem ou link)
    formaPagamentoLink: null, // Link da forma de pagamento quando houver
    showSelecaoFormaPagamentoDialog: false, // Controla exibição do diálogo de seleção
    idDocumentoSelecionado: null, // ID do documento selecionado para gerar forma de pagamento

    // Minhas Interações
    showInteracoesDialog: false, // Controla exibição do diálogo de interações
    loadingInteracoes: false, // Controla o estado de carregamento das interações

    // Arquivos Enviados
    showArquivosDialog: false, // Controla exibição do diálogo de arquivos enviados
    loadingArquivos: false, // Controla o estado de carregamento dos arquivos
    arquivosProtocolo: [], // Lista de arquivos enviados no protocolo atual (vem da API)
    interacoes: [], // Lista de interações
    searchInteracoes: "", // Texto para filtrar interações na tabela
    arquivosHeaders: [
      { text: "ID", value: "id", width: "5%" },
      { text: "Tipo", value: "tipoValor", width: "15%" },
      { text: "Valor", value: "valor", width: "15%" },
      { text: "Data", value: "dataCreate", width: "15%" },
      { text: "Usuário", value: "userInsert", width: "15%" },
      { text: "URL", value: "url", width: "20%" },
      {
        text: "Ações",
        value: "actions",
        sortable: false,
        align: "center",
        width: "15%",
      },
    ],

    interacoesHeaders: [
      { text: "ID", value: "idInteracao" },
      { text: "Data", value: "dtInteracao" },
      { text: "Cliente", value: "cliente" },
      { text: "Telefone", value: "telefone" },
      { text: "Status", value: "status", sortable: false },
      { text: "Ações", value: "actions", sortable: false, align: "center" },
    ],

    // Transferência de atendimento
    showTransferDialog: false,
    showParticipantDialog: false,
    searchColaborador: "",
    colaboradores: [],
    selectedColaboradores: [],
    loadingColaboradores: false,
    transferringAttendance: false,
    addingParticipant: false,
    removingParticipant: false,
    colaboradoresHeaders: [
      { text: "Nome", value: "nome", align: "start" },
      { text: "E-mail", value: "email" },
      { text: "Departamento", value: "departamento" },
    ],
  }),

  computed: {
    isMobile() {
      return this.$vuetify && this.$vuetify.breakpoint
        ? this.$vuetify.breakpoint.smAndDown
        : false;
    },

    empresasFiltradas() {
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
    clientsCount() {
      return this.clients ? this.clients.length : 0;
    },

    // Propriedade clients para armazenar a lista de clientes
    clients() {
      return this.clientsData || [];
    },

    telefoneEmpresa() {
      if (!this.selectedEmpresa || this.selectedEmpresa === "Todas") {
        return "558282308177";
      }

      const empresaAtual = this.selectedEmpresa;
      const mapeamentoEmpresas = {
        PREVIDA: "558282308177",
        Previda: "558282308177",
        previda: "558282308177",
        "MEMORIAL PARQUE MACEIÓ": "558299289412",
        "MEMORIAL PARQUE MACEIO": "558299289412",
        "Memorial Parque Maceió": "558299289412",
        "Memorial Parque Maceio": "558299289412",
        "Parque das Flores": "558296411028",
        "PARQUE DAS FLORES": "558296411028",
        "CEMITERIO PREVIDA": "558000829000",
        "Cemitério Previda": "558000829000",
        "CEMITERIO PREVIDA SÃO MIGUEL": "558000829000",
        "Cemitério Previda São Miguel": "558000829000",
        "PARQUE DO AGRESTE": "558000829000",
        "Parque do Agreste": "558000829000",
      };

      const normalizar = (str) => {
        return str
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase();
      };

      if (mapeamentoEmpresas[empresaAtual]) {
        return mapeamentoEmpresas[empresaAtual];
      }

      const empresaUpper = empresaAtual.toUpperCase();
      if (mapeamentoEmpresas[empresaUpper]) {
        return mapeamentoEmpresas[empresaUpper];
      }

      const empresaNormalizada = normalizar(empresaAtual);
      for (const [key, telefone] of Object.entries(mapeamentoEmpresas)) {
        if (normalizar(key) === empresaNormalizada) {
          return telefone;
        }
      }

      if (empresaNormalizada.includes("CEMITERIO")) {
        return "558000829000";
      }

      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("AGRESTE")
      ) {
        return "558000829000";
      }

      if (empresaNormalizada.includes("PREVIDA")) {
        return "558282308177";
      }
      if (
        empresaNormalizada.includes("MEMORIAL") &&
        empresaNormalizada.includes("MACEIO")
      ) {
        return "558299289412";
      }
      if (
        empresaNormalizada.includes("PARQUE") &&
        empresaNormalizada.includes("FLORES")
      ) {
        return "558296411028";
      }

      // Retorna null se não encontrou correspondência (empresa sem telefone cadastrado)
      console.warn(
        "Empresa não mapeada:",
        empresaAtual,
        "Sem telefone cadastrado",
      );

      return null;
    },

    empresaSelecionada() {
      return !!this.selectedEmpresa;
    },
    filaFilterOptions() {
      return this.filaOptions.map((fila) => ({
        value: fila.id,
        label: fila.nomeFila || fila.nome_fila || fila.nome || `Fila ${fila.id}`,
      }));
    },
    // Formatação da data de início no formato brasileiro
    filtroDataInicioFormatada: {
      get() {
        if (!this.filtroDataInicio) return "";
        const [year, month, day] = this.filtroDataInicio.split("-");
        return `${day}/${month}/${year}`;
      },
      set(value) {
        // Quando o campo é editado manualmente, não fazemos nada
        // pois o campo é readonly e só é alterado pelo date picker
      },
    },

    // Formatação da data de fim no formato brasileiro
    filtroDataFimFormatada: {
      get() {
        if (!this.filtroDataFim) return "";
        const [year, month, day] = this.filtroDataFim.split("-");
        return `${day}/${month}/${year}`;
      },
      set(value) {
        // Quando o campo é editado manualmente, não fazemos nada
        // pois o campo é readonly e só é alterado pelo date picker
      },
    },

    activeTemplates() {
      if (!this.templates || !this.templates.length) return [];

      // Filter only active templates
      return this.templates.filter(
        (template) => template.status_cliente === "ATIVO",
      );
    },

    // Obter nome do usuário logado
    loggedUserName() {
      try {
        const user = JSON.parse(sessionStorage.getItem("user"));
        return user ? user.nome : null;
      } catch (error) {
        console.error("Erro ao obter nome do usuário:", error);
        return null;
      }
    },

    // Verificar se o usuário logado é o atendente do protocolo atual
    isCurrentUserAttendant() {
      if (!this.selectedProtocolData || !this.loggedUserName) {
        return false;
      }
      return this.selectedProtocolData.emAtendimento === this.loggedUserName;
    },

    // Verificar se o usuário logado é participante do protocolo atual
    isCurrentUserParticipant() {
      if (!this.selectedProtocolData || !this.loggedUserName) {
        return false;
      }
      return this.selectedProtocolData.visitante === this.loggedUserName;
    },

    // Protocolos filtrados apenas por busca (o filtro de status é feito no backend)
    filteredProtocols() {
      let filtered = this.openProtocols;

      // Não filtrar por status - isso já é feito no backend

      // Não filtrar por usuário logado - visão macro de todos os protocolos

      // Filtrar por busca (protocolo ou contato)
      if (this.protocolSearch && this.protocolSearch.trim() !== "") {
        const searchTerm = this.protocolSearch.toLowerCase().trim();

        filtered = filtered.filter((protocol) => {
          // Buscar no número do protocolo
          const protocoloMatch = protocol.protocolo
            ? protocol.protocolo.toLowerCase().includes(searchTerm)
            : false;

          // Buscar no número do contato
          const contatoMatch = protocol.numeroDoContato
            ? protocol.numeroDoContato.toLowerCase().includes(searchTerm)
            : false;

          return protocoloMatch || contatoMatch;
        });
      }

      return filtered;
    },
    totalFilteredProtocols() {
      return this.filteredProtocols.length;
    },
    totalMessages() {
      return this.filteredProtocols.reduce(
        (total, protocol) => total + Number(protocol.messageCount || 0),
        0,
      );
    },
    openProtocolsLastCustomerMessage() {
      return this.filteredProtocols.filter((protocol) => {
        const status = String(protocol.status || "").toLowerCase();
        const direction = String(
          (protocol.ultimaMensagem && protocol.ultimaMensagem.direction) || "",
        ).toLowerCase();
        return status === "open" && direction === "incoming";
      }).length;
    },
  },

  created() {
    this.authenticate();

    // Inicializar datas com o período padrão (mês atual)
    this.definirPeriodoPadrao();
  },

  watch: {
    isAuthenticated(val) {
      if (val) {
        if (this.selectedEmpresa) {
          this.loadFilaOptions();
          this.buscarProtocolos();
        }
      }
    },
    selectedEmpresa() {
      this.selectedFilas = [];
      this.loadFilaOptions();
    },
  },

  mounted() {
    // Iniciar consulta periódica se já tiver um protocolo
    if (this.currentProtocol) {
      this.startMessagePolling();
    }
  },

  beforeDestroy() {
    // Limpar intervalo quando o componente for destruído
    this.stopMessagePolling();
  },

  methods: {
    hasPermission(empresa) {
      let user = null;
      try {
        user = JSON.parse(sessionStorage.getItem("user"));
      } catch (e) {
        user = null;
      }

      const roles = Array.isArray(user?.roles) ? user.roles : [];

      if (roles.includes("ROLE_ADMIN")) {
        return true;
      }

      if (empresa === "Todas") {
        return true;
      }

      const requiredRoles = String(empresa)
        .split(",")
        .map((name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_"));

      return requiredRoles.some((role) => roles.includes(role));
    },

    async authenticate() {
      try {
        const response = await SonaxService.authenticate();

        if (response.data && !response.data.error) {
          // Token não é mais necessário, backend gerencia
          this.isAuthenticated = true;
        } else {
          this.authError = response.data?.message || "Falha na autenticação";
        }
      } catch (error) {
        console.error("Erro na autenticação:", error);
        this.authError =
          error.response?.data?.message ||
          error.message ||
          "Erro na autenticação";
      }
    },

    // Interpretar status do ACK
    // ACK "1" = Enviado, ACK "2" = Entregue, ACK "3" = Lido, ACK "-2" = Erro
    interpretarStatus(ack) {
      switch (ack) {
        case "0":
        case "1":
          return {
            status: "sent",
            label: "Enviado",
            isDelivered: false,
            isRead: false,
          };
        case "2":
          return {
            status: "delivered",
            label: "Entregue",
            isDelivered: true,
            isRead: false,
          };
        case "3":
          return {
            status: "read",
            label: "Lido",
            isDelivered: true,
            isRead: true,
          };
        case "-2":
          return {
            status: "error",
            label: "Erro",
            isDelivered: false,
            isRead: false,
          };
        default:
          return {
            status: "sent",
            label: "Enviado",
            isDelivered: false,
            isRead: false,
          };
      }
    },

    // Processar mensagens para adicionar status baseado no ACK
    processarStatusMensagens(mensagens) {
      return mensagens.map((mensagem) => {
        // Apenas processar mensagens enviadas que têm ACK
        if (
          mensagem.direction === "outgoing" &&
          mensagem.ack !== undefined &&
          mensagem.ack !== null
        ) {
          const statusInfo = this.interpretarStatus(mensagem.ack);
          return {
            ...mensagem,
            readStatus: statusInfo.status,
            isDelivered: statusInfo.isDelivered,
            isRead: statusInfo.isRead,
            statusLabel: statusInfo.label,
          };
        }
        return mensagem;
      });
    },

    // Verificar contato antes de enviar mensagem
    async checkContactAndSend() {
      if (!this.$refs.form.validate()) return;

      // Validar telefone
      if (!this.phoneNumber) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone é obrigatório",
          color: "error",
        });
        return;
      }

      this.checkingContact = true;

      try {
        // Formatar telefone com prefixo 55
        const telefoneFormatado = this.phoneNumber.startsWith("55")
          ? this.phoneNumber.replace("55", "")
          : this.phoneNumber;

        // Buscar protocolos por telefone
        const from = this.selectedTemplate
          ? this.selectedTemplate.brokerNumber
          : "558282308177";
        const response = await SonaxService.getProtocolsByPhone(
          telefoneFormatado,
          from,
        );

        console.log("Resposta da busca de protocolos:", response.data);

        if (response.data) {
          // Verificar se há protocolos abertos (status === "open")
          const protocolosAbertos = Array.isArray(response.data)
            ? response.data.filter((protocolo) => protocolo.status === "open")
            : [];

          if (protocolosAbertos.length > 0) {
            console.log(
              "Protocolo aberto detectado! Bloqueando envio de mensagem.",
            );
            // Mostrar diálogo informando sobre protocolo existente
            const ultimoProtocolo = protocolosAbertos[0]; // Pegar o primeiro protocolo aberto
            this.contactInfo = {
              data: {
                numeroTelefone: telefoneFormatado,
                protocolosAbertos: protocolosAbertos,
                ultimoProtocolo: ultimoProtocolo,
                protocolNumber: ultimoProtocolo.protocolNumber,
                numeroDoContato: ultimoProtocolo.numeroDoContato,
                dataCreate: ultimoProtocolo.dataCreate,
                userInsert: ultimoProtocolo.userInsert,
              },
            };
            this.showProtocolDialog = true;
            this.checkingContact = false;
            return; // IMPORTANTE: retorna aqui para não prosseguir com o envio
          } else {
            console.log(
              "Nenhum protocolo aberto encontrado, prosseguindo com envio...",
            );
          }
        }

        // Se não tem protocolo aberto, prosseguir com o envio
        console.log("Prosseguindo com proceedWithSend()...");
        await this.proceedWithSend();
      } catch (error) {
        console.error("Erro ao verificar contato:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao verificar contato",
          color: "error",
        });
      } finally {
        this.checkingContact = false;
      }
    },

    // Fechar diálogo de protocolo existente
    closeProtocolDialog() {
      this.showProtocolDialog = false;
      this.contactInfo = null;
    },

    // Prosseguir com o envio da mensagem
    async proceedWithSend() {
      this.sendingMessage = true;

      try {
        // Format params as comma-separated string
        const paramsTemplate = this.templateParams
          .map((p) => p.trim())
          .join(",");

        const response = await SonaxService.sendMessage({
          message: this.selectedTemplate.name,
          to: this.phoneNumber,
          from: this.selectedTemplate.brokerNumber,
          paramsTemplate,
          primeiroContato: true, // Mensagem do diálogo de novo atendimento
        });

        if (response.data && !response.data.error && response.data.protocol) {
          this.currentProtocol = response.data.protocol.protocol_number;
          this.$nextTick(async () => {
            // Atualizar lista de protocolos primeiro
            await this.fetchProtocolsByStatus();

            // Encontrar o protocolo recém-criado na lista atualizada e atualizar selectedProtocolData
            const newProtocol = this.openProtocols.find(
              (p) => p.protocolo === this.currentProtocol,
            );
            if (newProtocol) {
              this.selectedProtocolData = newProtocol;
            }

            this.fetchMessages();
            // Iniciar consulta periódica de mensagens (a cada 1 minuto)
            this.startMessagePolling();
          });

          // Limpar formulário e fechar diálogo
          this.closeNewAttendanceDialog();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao enviar mensagem",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao enviar mensagem",
          color: "error",
        });
      } finally {
        this.sendingMessage = false;
      }
    },

    async fetchMessages() {
      if (!this.currentProtocol) return;

      this.loadingMessages = true;

      try {
        const response = await SonaxService.getMessages(this.currentProtocol);

        if (response.data && !response.data.error && response.data.data) {
          // Processar mensagens e adicionar status baseado no ACK
          this.messages = this.processarStatusMensagens(response.data.data);
          this.arquivosProtocolo = response.data.arquivos;

          // Se tiver mensagens, pegar o ID do protocolo da primeira mensagem
          if (
            this.messages.length > 0 &&
            this.messages[0].protocol &&
            this.messages[0].protocol._id
          ) {
            this.currentProtocolId = this.messages[0].protocol._id;
          }
        }
      } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao buscar mensagens",
          color: "error",
        });
      } finally {
        this.loadingMessages = false;
      }
    },

    // Copiar URL para a área de transferência
    copiarUrl(url) {
      if (!url) return;

      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.$store?.dispatch("showSnackbar", {
            text: "URL copiada para a área de transferência",
            color: "success",
          });
        })
        .catch((err) => {
          console.error("Erro ao copiar URL: ", err);
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao copiar URL",
            color: "error",
          });
        });
    },

    // Obter ícone para o tipo de arquivo
    getFileTypeIcon(type, url) {
      if (type !== "file") return "mdi-file-outline";

      if (this.isImage(url)) return "mdi-file-image-outline";
      return "mdi-file-video-outline"; // Considerando que são todos vídeos se não forem imagens
    },

    // Obter cor para o tipo de arquivo
    getFileTypeColor(type, url) {
      if (type !== "file") return "grey";

      if (this.isImage(url)) return "primary";
      return "purple"; // Cor para vídeos
    },

    // Obter nome para o tipo de arquivo
    getFileTypeName(type, url) {
      if (type !== "file") return "Arquivo";

      if (this.isImage(url)) return "Imagem";
      return "Vídeo";
    },

    refreshMessages() {
      this.fetchMessages();
    },

    // Iniciar consulta periódica de mensagens
    startMessagePolling() {
      // Limpar qualquer intervalo existente
      this.stopMessagePolling();

      // Configurar novo intervalo (a cada 1 minuto)
      this.messagePollingInterval = setInterval(() => {
        if (this.currentProtocol) {
          this.fetchMessagesWithoutLoading();
        }
      }, 60000); // 1 minuto
    },

    // Parar consulta periódica de mensagens
    stopMessagePolling() {
      if (this.messagePollingInterval) {
        clearInterval(this.messagePollingInterval);
        this.messagePollingInterval = null;
      }
    },

    // Enviar mensagem de texto livre
    async sendFreeTextMessage() {
      if (!this.freeTextMessage || !this.currentProtocol) return;

      // Obter o número do telefone do protocolo selecionado
      let phoneNumberToSend = this.phoneNumber;

      // Se phoneNumber estiver vazio, pegar do protocolo selecionado
      if (!phoneNumberToSend && this.selectedProtocolData) {
        phoneNumberToSend = this.selectedProtocolData.numeroDoContato.replace(
          /^\+?55/,
          "",
        );
      }

      // Se ainda estiver vazio, tentar pegar das mensagens
      if (!phoneNumberToSend && this.messages.length > 0) {
        const firstMessage = this.messages[0];
        if (firstMessage.to) {
          phoneNumberToSend = firstMessage.to.replace(/^\+?55/, "");
        } else if (firstMessage.from) {
          phoneNumberToSend = firstMessage.from.replace(/^\+?55/, "");
        }
      }

      if (!phoneNumberToSend) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone não encontrado",
          color: "error",
        });
        this.sendingMessage = false;
        return;
      }

      // Garantir que o número tenha o prefixo 55
      const telefoneFormatado = phoneNumberToSend.startsWith("55")
        ? phoneNumberToSend
        : `55${phoneNumberToSend}`;

      this.sendingMessage = true;

      try {
        // Para mensagens de texto livre, enviar paramsTemplate como string vazia
        // A API Sonax diferencia template (com paramsTemplate preenchido) de texto livre (paramsTemplate vazio)
        const messageData = {
          message: this.freeTextMessage,
          to: telefoneFormatado,
          from: this.selectedTemplate
            ? this.selectedTemplate.brokerNumber
            : "558282308177",
          paramsTemplate: "", // String vazia indica que é texto livre, não template
          primeiroContato: false, // Mensagem do chat (não é primeiro contato)
        };

        const response = await SonaxService.sendMessage(messageData);

        if (response.data && !response.data.error) {
          // Limpar a mensagem após envio
          this.freeTextMessage = "";

          // Atualizar mensagens sem mostrar o loader
          await this.fetchMessagesWithoutLoading();
        } else {
          // Verificar se o erro é relacionado a protocolo não existente
          const errorMessage = response.data?.message || "";
          if (
            errorMessage.includes("Não foi possível encontrar o template") ||
            errorMessage.includes("template informado")
          ) {
            this.$store?.dispatch("showSnackbar", {
              text: "Não é possível enviar texto livre sem um protocolo existente. Por favor, crie um novo atendimento com template primeiro.",
              color: "error",
            });
          } else {
            this.$store?.dispatch("showSnackbar", {
              text: errorMessage || "Erro ao enviar mensagem",
              color: "error",
            });
          }
        }
      } catch (error) {
        console.error("Erro ao enviar mensagem de texto:", error);
        const errorMessage =
          error.response?.data?.message ||
          error.message ||
          "Erro ao enviar mensagem";

        // Verificar se o erro é relacionado a protocolo não existente
        if (
          errorMessage.includes("Não foi possível encontrar o template") ||
          errorMessage.includes("template informado")
        ) {
          this.$store?.dispatch("showSnackbar", {
            text: "Não é possível enviar texto livre sem um protocolo existente. Por favor, crie um novo atendimento com template primeiro.",
            color: "error",
          });
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: errorMessage,
            color: "error",
          });
        }
      } finally {
        this.sendingMessage = false;
      }
    },

    // Buscar mensagens sem mostrar o loader
    async fetchMessagesWithoutLoading() {
      if (!this.currentProtocol) return;

      try {
        const response = await SonaxService.getMessages(this.currentProtocol);

        if (response.data && !response.data.error && response.data.data) {
          // Processar mensagens e adicionar status baseado no ACK
          const newMessages = this.processarStatusMensagens(response.data.data);

          // Verificar se há novas mensagens (comparar por IDs)
          const existingIds = new Set(this.messages.map((m) => m._id));
          const hasNewMessages = newMessages.some(
            (m) => !existingIds.has(m._id),
          );

          if (hasNewMessages) {
            // Atualizar lista completa
            this.messages = newMessages;

            // Rolar para o final da conversa
            this.scrollToBottom();
          } else {
            // Mesmo sem novas mensagens, atualizar para pegar mudanças de status
            this.messages = newMessages;
          }

          // Se tiver mensagens, pegar o ID do protocolo da primeira mensagem
          if (
            newMessages.length > 0 &&
            newMessages[0].protocol &&
            newMessages[0].protocol._id
          ) {
            this.currentProtocolId = newMessages[0].protocol._id;
          }
        }
      } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
      }
    },

    // Alternar entre mostrar e esconder mensagens históricas
    async toggleHistoricalMessages() {
      // Se já está mostrando, apenas esconde
      if (this.showingHistoricalMessages) {
        this.showingHistoricalMessages = false;
        return;
      }

      // Se já tem mensagens históricas carregadas, apenas mostra
      if (this.historicalMessages.length > 0) {
        this.showingHistoricalMessages = true;
        return;
      }

      // Se não tem mensagens históricas, carrega e mostra
      await this.loadMoreMessages();
    },

    // Carregar mais mensagens (histórico)
    async loadMoreMessages() {
      if (
        !this.selectedProtocolData ||
        !this.selectedProtocolData.numeroDoContato
      ) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone não encontrado",
          color: "error",
        });
        return;
      }

      // Formatar telefone (remover prefixo +55 se existir)
      const telefone = this.selectedProtocolData.numeroDoContato.replace(
        /^\+?55/,
        "",
      );

      try {
        // Mostrar loading
        this.loadingMessages = true;

        // Buscar mensagens por telefone
        const response = await SonaxService.getMessagesByPhone(
          this.currentProtocol
        );

        // Log simples para debug
        console.log(
          `Buscando histórico de mensagens para o telefone: ${telefone}`,
        );

        // Processar e adicionar mensagens do histórico ao chat
        if (response.data && response.data.mensagensPorProtocolo) {
          // Obter todas as mensagens de todos os protocolos
          let todasMensagens = [];

          // Iterar sobre cada protocolo e suas mensagens
          Object.keys(response.data.mensagensPorProtocolo).forEach(
            (protocolo) => {
              const mensagensDoProtocolo =
                response.data.mensagensPorProtocolo[protocolo];
              if (Array.isArray(mensagensDoProtocolo)) {
                // Processar cada mensagem para o formato esperado pelo chat
                const mensagensProcessadas = mensagensDoProtocolo.map(
                  (msg) => ({
                    _id: msg.messageId,
                    direction: msg.direction,
                    message: msg.message,
                    message_type: msg.messageType,
                    createdAt: msg.createdAt,
                    ack: msg.ack,
                    protocol: {
                      _id: msg.protocolId,
                      protocol_number: msg.protocolNumber,
                    },
                    userInsert: msg.userInsert,
                    isHistorical: true,
                    ...this.interpretarStatus(msg.ack),
                  }),
                );

                todasMensagens = [...todasMensagens, ...mensagensProcessadas];
              }
            },
          );

          // Ordenar mensagens por data (mais antigas primeiro)
          todasMensagens.sort(
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
          );

          // Verificar se já existem mensagens com os mesmos IDs para evitar duplicação
          const idsHistoricos = new Set(
            this.historicalMessages.map((m) => m._id),
          );
          const novasMensagens = todasMensagens.filter(
            (m) => !idsHistoricos.has(m._id),
          );

          if (novasMensagens.length > 0) {
            // Atualizar a lista de mensagens históricas
            this.historicalMessages = [
              ...this.historicalMessages,
              ...novasMensagens,
            ];

            // Ativar a exibição das mensagens históricas
            this.showingHistoricalMessages = true;

            this.$store?.dispatch("showSnackbar", {
              text: `${novasMensagens.length} mensagens históricas carregadas`,
              color: "success",
            });
          } else {
            this.$store?.dispatch("showSnackbar", {
              text: "Nenhuma nova mensagem histórica encontrada",
              color: "info",
            });
          }
        }
      } catch (error) {
        console.error("Erro ao buscar mensagens por telefone:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message ||
            "Erro ao buscar mensagens por telefone",
          color: "error",
        });
      } finally {
        this.loadingMessages = false;
      }
    },

    toggleClientDetails() {
      // Se já está mostrando, apenas esconde
      if (this.showingClientDetails) {
        this.showingClientDetails = false;
        return;
      }

      // Se não está mostrando, mostra e busca informações do cliente
      this.showingClientDetails = true;
      this.fetchClientInfo();
    },

    // Buscar informações do cliente
    async fetchClientInfo() {
      if (
        !this.selectedProtocolData ||
        !this.selectedProtocolData.numeroDoContato
      ) {
        this.clientInfoError = "Número de telefone não encontrado";
        return;
      }

      // Formatar telefone (remover prefixo +55 se existir)
      const telefone = this.selectedProtocolData.numeroDoContato.replace(
        /^\+?55/,
        "",
      );

      this.loadingClientInfo = true;
      this.clientInfoError = null;

      try {
        const response = await SonaxService.getClienteInfo(
          telefone,
          "telefone",
          this.selectedEmpresa
        );
        const responseProtocolos = await SonaxService.getProtocolsByPhone(
          telefone,
          this.telefoneEmpresa
        );

        if (response.data && response.data.length > 0) {
          // Armazena a lista completa de clientes
          this.clientsData = response.data;

          // Define o primeiro cliente como selecionado por padrão
          this.selectedClientIndex = 0;

          // Define as informações do cliente selecionado
          this.updateSelectedClientInfo(responseProtocolos.data);
          this.loadingClientInfo = false;
        } else {
          this.clientsData = [];
          this.clientInfo = null;
          this.clientInfoError =
            "Nenhuma informação disponível para este cliente";
        }
      } catch (error) {
        console.error("Erro ao buscar informações do cliente:", error);
        this.clientsData = [];
        this.clientInfo = null;
        this.clientInfoError =
          error.response?.data || "Erro ao buscar informações do cliente";
      } finally {
        this.loadingClientInfo = false;
      }
    },

    updateSelectedClientInfo(protocolos = []) {
      if (
        this.clients.length > 0 &&
        this.selectedClientIndex >= 0 &&
        this.selectedClientIndex < this.clients.length
      ) {
        this.clientInfo = this.clients[this.selectedClientIndex];
        this.clientInfo.protocolos = protocolos;
      } else {
        this.clientInfo = null;
      }
    },

    // Formatar CPF (XXX.XXX.XXX-XX)
    formatCpf(cpf) {
      if (!cpf) return "Não informado";

      const cpfClean = cpf.replace(/\D/g, "");
      if (cpfClean.length !== 11) return cpf;

      const initialDigits = cpfClean.slice(0, 3);
      const lastDigits = cpfClean.slice(-2);

      return `${initialDigits}.***.***-${lastDigits}`;
    },

    formatDateBR(date) {
      if (!date) return "Não informado";

      // Converter para formato brasileiro
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },

    getVencimentoColor(dataVencimento, status) {
      if (!dataVencimento) return "grey";

      // Se já foi pago ou quitado
      if (
        status &&
        (status.toLowerCase().includes("pago") ||
          status.toLowerCase().includes("quitado"))
      ) {
        return "success";
      }

      // Verificar se está vencido
      const hoje = new Date();
      const vencimento = new Date(dataVencimento);

      if (vencimento < hoje) {
        return "error";
      } else {
        return "success";
      }
    },

    // Determinar texto do status de vencimento
    getVencimentoStatus(dataVencimento, status) {
      if (!dataVencimento) return "Sem data";

      // Verificar se está vencido
      const hoje = new Date();
      const vencimento = new Date(dataVencimento);

      if (vencimento < hoje) {
        return "Vencido";
      } else {
        // Está dentro do prazo
        return "A vencer";
      }
    },

    // Formatar data como YYYY-MM-DD
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // Definir período padrão (mês atual)
    definirPeriodoPadrao() {
      const hoje = new Date();
      const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
      const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

      // Formato ISO (YYYY-MM-DD) para consulta na API
      this.filtroDataInicio = this.formatDate(primeiroDiaMes);
      this.filtroDataFim = this.formatDate(hoje);
    },

    async loadFilaOptions() {
      this.filaOptions = [];
      if (!this.selectedEmpresa) {
        return;
      }

      this.loadingFilas = true;
      try {
        const response = await SonaxService.listarFilaTemplatesEmpresa(
          this.selectedEmpresa,
        );
        this.filaOptions = Array.isArray(response.data) ? response.data : [];
      } catch (error) {
        console.error("Erro ao carregar filas:", error);
        this.filaOptions = [];
      } finally {
        this.loadingFilas = false;
      }
    },

    // Buscar protocolos com base nos filtros de data e status
    async buscarProtocolos() {
      // Validar datas
      if (!this.filtroDataInicio || !this.filtroDataFim) {
        console.warn("Por favor, selecione as datas inicial e final.");
        return;
      }

      if (!this.selectedEmpresa) {
        console.warn(
          "Por favor, selecione uma empresa no filtro antes de buscar protocolos.",
        );
        return;
      }

      // Chamar fetchProtocolsByStatus com as datas e status selecionados
      await this.fetchProtocolsByStatus(
        this.filtroDataInicio,
        this.filtroDataFim,
        this.protocolStatusFilter,
        this.selectedEmpresa,
        this.selectedFilas,
        true,
      );
    },

    // Buscar protocolos por status no período especificado
    async fetchProtocolsByStatus(
      dataInicio,
      dataFim,
      status,
      empresa,
      idFila = this.selectedFilas,
      alerta = true,
    ) {
      this.loadingProtocols = alerta;

      try {
        // Se não foram fornecidas datas, usar as datas já definidas no componente
        if (!dataInicio || !dataFim) {
          // Se as datas do componente também não estiverem definidas, usar o período padrão
          if (!this.filtroDataInicio || !this.filtroDataFim) {
            this.definirPeriodoPadrao();
          }

          dataInicio = this.filtroDataInicio;
          dataFim = this.filtroDataFim;
        } else {
          // Atualizar os campos de data no formulário com as datas fornecidas
          this.filtroDataInicio = dataInicio;
          this.filtroDataFim = dataFim;
        }

        // Se não foi fornecido status, usar "todos"
        if (!status) {
          status = this.protocolStatusFilter;
        }

        if (!empresa) {
          empresa = this.selectedEmpresa;
        }

        /* const telefoneEmpresa = this.telefoneEmpresa;
        if (!telefoneEmpresa) {
          this.loadingProtocols = false;
          console.warn("Empresa selecionada sem telefone cadastrado.");
          return;
        } */

        const response = await SonaxService.getProtocolsByStatus(
          dataInicio,
          dataFim,
          status,
          null,
          empresa,
          idFila || [],
        );

        if (response.data && !response.data.error && response.data.data) {
          // Armazenar os protocolos retornados pela API
          this.openProtocols = response.data.data;
          this.totalProtocols = this.openProtocols.length;
        }
      } catch (error) {
        console.error("Erro ao buscar protocolos por status:", error);
      } finally {
        this.loadingProtocols = false;
      }
    },

    // Selecionar um protocolo para visualização
    async selectProtocol(protocol) {
      // Parar qualquer consulta periódica anterior
      this.stopMessagePolling();

      // Armazenar dados do protocolo selecionado
      this.selectedProtocolData = protocol;
      this.currentProtocol = protocol.protocolo;
      this.phoneNumber = protocol.numeroDoContato.replace(/^\+?55/, ""); // Remover prefixo +55 se existir

      // Limpar mensagens históricas ao selecionar um novo protocolo
      this.historicalMessages = [];
      // Ocultar a exibição das mensagens históricas
      this.showingHistoricalMessages = false;

      // Buscar mensagens do protocolo
      await this.fetchMessages();
      this.scrollToBottom(true);

      // Iniciar consulta periódica
      this.startMessagePolling();

      // Atualizar a lista de protocolos
      this.fetchProtocolsByStatus(null, null, null, null, this.selectedFilas, false);
    },

    voltarParaListaProtocolos() {
      this.stopMessagePolling();
      this.currentProtocol = null;
      this.currentProtocolId = null;
      this.selectedProtocolData = null;
      this.messages = [];
      this.historicalMessages = [];
      this.showingHistoricalMessages = false;
      this.showingClientDetails = false;
    },

    // Confirmar fechamento de protocolo
    confirmCloseProtocol() {
      this.showCloseProtocolConfirmDialog = true;
    },

    // Fechar diálogo de confirmação
    cancelCloseProtocol() {
      this.showCloseProtocolConfirmDialog = false;
    },

    // Executar fechamento de protocolo
    async executeCloseProtocol() {
      this.showCloseProtocolConfirmDialog = false;

      if (!this.currentProtocolId) {
        this.$nextTick(() => {
          this.$store?.dispatch("showSnackbar", {
            text: "ID do protocolo não encontrado",
            color: "error",
          });
        });
        return;
      }

      this.closingProtocol = true;

      try {
        // Obter telefone do protocolo selecionado (to)
        let to = null;
        if (this.selectedProtocolData?.numeroDoContato) {
          to = this.selectedProtocolData.numeroDoContato;
          // Garantir que tenha o prefixo 55
          if (!to.startsWith("55")) {
            to = `55${to.replace(/^\+?55/, "")}`;
          }
        }

        // Obter from (número do broker) - usar o mesmo padrão do envio de mensagens
        const from = this.telefoneEmpresa ? this.telefoneEmpresa : null;

        if (!to || !from) {
          this.$store?.dispatch("showSnackbar", {
            text: "Número de telefone não encontrado",
            color: "error",
          });
          this.closingProtocol = false;
          return;
        }

        const response = await SonaxService.closeProtocol(
          this.currentProtocolId,
          this.currentProtocol,
          to,
          from,
        );

        if (response.data && !response.data.error) {
          this.$nextTick(() => {
            this.$store?.dispatch("showSnackbar", {
              text: "Protocolo fechado com sucesso",
              color: "success",
            });
          });

          // Parar a consulta periódica
          this.stopMessagePolling();

          // Limpar protocolo atual
          this.currentProtocol = null;
          this.currentProtocolId = null;
          this.selectedProtocolData = null;
          this.messages = [];

          // Atualizar a lista de protocolos
          this.fetchProtocolsByStatus(null, null, null, null, this.selectedFilas, true);
        } else {
          this.$nextTick(() => {
            this.$store?.dispatch("showSnackbar", {
              text: response.data?.message || "Erro ao fechar protocolo",
              color: "error",
            });
          });
        }
      } catch (error) {
        console.error("Erro ao fechar protocolo:", error);
        this.$nextTick(() => {
          this.$store?.dispatch("showSnackbar", {
            text: error.response?.data?.message || "Erro ao fechar protocolo",
            color: "error",
          });
        });
      } finally {
        this.closingProtocol = false;
      }
    },

    async abrirProtocolo(protocolo) {
      if (!protocolo || !protocolo.protocolNumber) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo inválido",
          color: "error",
        });
        return;
      }

      this.protocolMessagesLoading = true;
      this.protocolMessagesData = protocolo;
      this.showProtocolMessagesDialog = true;
      this.selectedProtocolMessages = [];

      try {
        const response = await SonaxService.getMessages(
          protocolo.protocolNumber,
        );

        if (response.data && !response.data.error && response.data.data) {
          // Processar mensagens e adicionar status baseado no ACK
          this.selectedProtocolMessages = this.processarStatusMensagens(
            response.data.data,
          );
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao carregar mensagens do protocolo",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao buscar mensagens do protocolo:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message ||
            "Erro ao buscar mensagens do protocolo",
          color: "error",
        });
      } finally {
        this.protocolMessagesLoading = false;
      }
    },

    // Fechar diálogo de mensagens do protocolo
    closeProtocolMessagesDialog() {
      this.showProtocolMessagesDialog = false;
      this.protocolMessagesData = null;
      this.selectedProtocolMessages = [];
    },

    // Vincular atendimento ao protocolo
    async vincularAtendimento() {
      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo não encontrado",
          color: "error",
        });
        return;
      }

      this.linkingAttendance = true;

      try {
        const response = await SonaxService.vincularAtendimento(
          this.currentProtocol,
        );

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: "Atendimento vinculado com sucesso",
            color: "success",
          });

          // Atualizar a lista de protocolos para refletir a mudança
          await this.fetchProtocolsByStatus();

          // Atualizar o selectedProtocolData para refletir a mudança
          const updatedProtocol = this.openProtocols.find(
            (p) => p.protocolo === this.currentProtocol,
          );
          if (updatedProtocol) {
            this.selectedProtocolData = updatedProtocol;
          }
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao vincular atendimento",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao vincular atendimento:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao vincular atendimento",
          color: "error",
        });
      } finally {
        this.linkingAttendance = false;
      }
    },

    // Desvincular atendimento do protocolo
    async desvincularAtendimento() {
      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo não encontrado",
          color: "error",
        });
        return;
      }

      this.unlinkingAttendance = true;

      try {
        const response = await SonaxService.desvincularAtendimento(
          this.currentProtocol,
        );

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: "Atendimento desvinculado com sucesso",
            color: "success",
          });

          // Atualizar a lista de protocolos para refletir a mudança
          await this.fetchProtocolsByStatus();

          // Atualizar o selectedProtocolData para refletir a mudança
          const updatedProtocol = this.openProtocols.find(
            (p) => p.protocolo === this.currentProtocol,
          );
          if (updatedProtocol) {
            this.selectedProtocolData = updatedProtocol;
          }
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao desvincular atendimento",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao desvincular atendimento:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message || "Erro ao desvincular atendimento",
          color: "error",
        });
      } finally {
        this.currentProtocol = null;
        this.fetchProtocolsByStatus();
        this.unlinkingAttendance = false;
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleString("pt-BR");
    },

    stripHtml(html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    },

    // Abrir diálogo de transferência de atendimento
    abrirDialogTransferencia() {
      this.showTransferDialog = true;
      this.selectedColaboradores = [];
      this.carregarColaboradores();
    },

    // Carregar lista de colaboradores ativos
    async carregarColaboradores() {
      this.loadingColaboradores = true;
      try {
        const response = await UsuarioService.todos_ativos_com_colaborador(
          this.selectedEmpresa,
        );

        if (response.data && Array.isArray(response.data)) {
          // Filtrar o usuário logado da lista de colaboradores
          const usuarioLogado = this.loggedUserName;

          this.colaboradores = response.data
            .filter((colaborador) => colaborador.nome !== usuarioLogado) // Remove o usuário logado da lista
            .map((colaborador) => ({
              id: colaborador.id,
              nome: colaborador.nome,
              email: colaborador.email,
              departamento: colaborador.departamento || "Não informado",
            }));

          console.log(
            `Filtrado usuário logado: ${usuarioLogado}. Total de colaboradores: ${this.colaboradores.length}`,
          );
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao carregar colaboradores: Formato de dados inválido",
            color: "error",
          });
          this.colaboradores = [];
        }
      } catch (error) {
        console.error("Erro ao carregar colaboradores:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message || "Erro ao carregar colaboradores",
          color: "error",
        });
        this.colaboradores = [];
      } finally {
        this.loadingColaboradores = false;
      }
    },

    // Executar transferência de atendimento
    async executarTransferencia() {
      if (!this.selectedColaboradores.length || !this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione um colaborador para transferir o atendimento",
          color: "warning",
        });
        return;
      }

      const colaboradorSelecionado = this.selectedColaboradores[0];
      this.transferringAttendance = true;

      try {
        const response = await SonaxService.transferirAtendimento(
          this.currentProtocol,
          colaboradorSelecionado.nome,
        );

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: `Atendimento transferido com sucesso para ${colaboradorSelecionado.nome}`,
            color: "success",
          });

          // Atualizar a lista de protocolos para refletir a mudança
          await this.fetchProtocolsByStatus();

          // Atualizar o selectedProtocolData para refletir a mudança
          const updatedProtocol = this.openProtocols.find(
            (p) => p.protocolo === this.currentProtocol,
          );
          if (updatedProtocol) {
            this.selectedProtocolData = updatedProtocol;
          }

          // Fechar o diálogo
          this.showTransferDialog = false;
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao transferir atendimento",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao transferir atendimento:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message || "Erro ao transferir atendimento",
          color: "error",
        });
      } finally {
        this.transferringAttendance = false;
        this.currentProtocol = null;
        this.fetchProtocolsByStatus();
      }
    },

    // Abrir diálogo de adicionar participante
    abrirDialogParticipante() {
      this.showParticipantDialog = true;
      this.selectedColaboradores = [];
      this.carregarColaboradores();
    },

    // Adicionar participante ao atendimento
    async adicionarParticipante() {
      const protocoloAtual = this.currentProtocol;
      if (!this.selectedColaboradores.length || !this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione um colaborador para adicionar como participante",
          color: "warning",
        });
        return;
      }

      const colaboradorSelecionado = this.selectedColaboradores[0];
      this.addingParticipant = true;

      try {
        const response = await SonaxService.adicionarVisitante(
          this.currentProtocol,
          colaboradorSelecionado.nome,
        );

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: `${colaboradorSelecionado.nome} adicionado como participante com sucesso`,
            color: "success",
          });

          // Fechar o diálogo
          this.showParticipantDialog = false;
          this.selectedColaboradores = [];
          this.searchColaborador = "";

          // Atualizar a lista de protocolos
          await this.fetchProtocolsByStatus();

          // Atualizar o selectedProtocolData para refletir a mudança
          if (this.currentProtocol) {
            const updatedProtocol = this.openProtocols.find(
              (p) => p.protocolo === this.currentProtocol,
            );
            if (updatedProtocol) {
              // Forçar a atualização do selectedProtocolData
              this.selectedProtocolData = { ...updatedProtocol };
              console.log(
                "SelectedProtocolData atualizado:",
                this.selectedProtocolData,
              );
            }
          }

          // Atualizar mensagens para mostrar a notificação de novo participante
          this.refreshMessages();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao adicionar participante",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao adicionar participante:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message || "Erro ao adicionar participante",
          color: "error",
        });
      } finally {
        this.addingParticipant = false;
      }
    },

    // Abrir diálogo de confirmação para remover participante
    confirmRemoveParticipant() {
      this.showRemoveParticipantConfirmDialog = true;
    },

    // Abrir diálogo de confirmação para sair do atendimento
    confirmExitAttendance() {
      this.showExitAttendanceConfirmDialog = true;
    },

    // Cancelar saída do atendimento
    cancelExitAttendance() {
      this.showExitAttendanceConfirmDialog = false;
    },

    // Executar saída do atendimento
    async executeExitAttendance() {
      this.showExitAttendanceConfirmDialog = false;

      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo não selecionado",
          color: "warning",
        });
        return;
      }

      await this.desvincularAtendimento();
    },

    // Cancelar remoção de participante ou saída do atendimento
    cancelRemoveParticipant() {
      this.showRemoveParticipantConfirmDialog = false;
    },

    // Executar remoção de participante ou saída do atendimento
    async executeRemoveParticipant(isAtendente) {
      this.showRemoveParticipantConfirmDialog = false;

      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo não selecionado",
          color: "warning",
        });
        return;
      }

      await this.removerParticipante(isAtendente);
    },

    // Remover participante do atendimento
    async removerParticipante(isAtendente) {
      if (!this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Protocolo não selecionado",
          color: "warning",
        });
        return;
      }

      const protocoloAtual = this.currentProtocol;
      this.removingParticipant = true;

      try {
        const response = await SonaxService.removerVisitante(
          this.currentProtocol,
        );

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: `Participante removido com sucesso`,
            color: "success",
          });

          // Atualizar a lista de protocolos
          await this.fetchProtocolsByStatus();
          if (isAtendente) {
            // Atualizar o selectedProtocolData para refletir a mudança
            // Manter o protocolo atual selecionado em vez de limpá-lo
            if (protocoloAtual) {
              const updatedProtocol = this.openProtocols.find(
                (p) => p.protocolo === protocoloAtual,
              );
              if (updatedProtocol) {
                // Forçar a atualização do selectedProtocolData
                this.selectedProtocolData = { ...updatedProtocol };
                console.log(
                  "SelectedProtocolData atualizado após remover participante:",
                  this.selectedProtocolData,
                );
              }
            }
          } else {
            this.currentProtocol = null;
          }

          // Atualizar mensagens
          this.refreshMessages();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao remover participante",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao remover participante:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao remover participante",
          color: "error",
        });
      } finally {
        this.removingParticipant = false;
      }
    },

    // Abrir diálogo de seleção de forma de pagamento
    abrirDialogSelecaoFormaPagamento(idDocumento) {
      this.idDocumentoSelecionado = idDocumento;
      this.showSelecaoFormaPagamentoDialog = true;
    },

    // Fechar diálogo de seleção de forma de pagamento
    closeSelecaoFormaPagamentoDialog() {
      // Não permite fechar durante o loading
      if (this.loadingFormaPagamento !== null) {
        return;
      }
      this.showSelecaoFormaPagamentoDialog = false;
      this.idDocumentoSelecionado = null;
    },

    // Selecionar forma de pagamento e chamar o método
    async selecionarFormaPagamento(formaPagamento) {
      // Não permite selecionar durante o loading
      if (this.loadingFormaPagamento !== null) {
        return;
      }

      // Salvar o ID antes de fechar o diálogo (que limpa a variável)
      const idDocumento = this.idDocumentoSelecionado;
      const protocolo = this.currentProtocol;

      // Mapear o label exibido para o valor que o backend espera
      let formaPagamentoParaEnviar = formaPagamento;
      if (formaPagamento === "PDF Boleto") {
        formaPagamentoParaEnviar = "PDF";
      } else if (formaPagamento === "Link de Pagamento") {
        formaPagamentoParaEnviar = "Link";
      } else if (formaPagamento === "Código de Barras") {
        formaPagamentoParaEnviar = "Barras";
      }
      // "Pix" permanece como "Pix"

      if (idDocumento) {
        // Não fecha o diálogo ainda, mantém aberto para mostrar o loading
        await this.gerarFormaPagamento(
          idDocumento,
          formaPagamentoParaEnviar,
          protocolo,
        );
        // Fechar o diálogo após o processamento (sucesso ou erro)
        this.closeSelecaoFormaPagamentoDialog();
      } else {
        this.$store?.dispatch("showSnackbar", {
          text: "ID do documento não encontrado",
          color: "error",
        });
      }
    },

    // Gerar forma de pagamento
    async gerarFormaPagamento(idDocumento, formaPagamento, protocolo) {
      if (!idDocumento) {
        this.$store?.dispatch("showSnackbar", {
          text: "ID do documento não encontrado",
          color: "error",
        });
        return;
      }

      if (!formaPagamento) {
        this.$store?.dispatch("showSnackbar", {
          text: "Forma de pagamento não selecionada",
          color: "error",
        });
        return;
      }

      this.loadingFormaPagamento = idDocumento;

      try {
        // Obter telefone do protocolo selecionado (remover prefixo 55 se existir)
        let telefone = null;
        if (this.selectedProtocolData?.numeroDoContato) {
          telefone = this.selectedProtocolData.numeroDoContato.replace(
            /^\+?55/,
            "",
          );
        }

        // Obter from (número do broker) - usar o mesmo padrão do envio de mensagens
        const from = this.selectedTemplate
          ? this.selectedTemplate.brokerNumber
          : "558282308177";

        const response = await SonaxService.gerarFormaPagamento(
          idDocumento,
          telefone,
          from,
          formaPagamento,
          protocolo,
        );

        if (response.data) {
          // Se tiver mensagem, exibir no diálogo
          if (response.data.message) {
            this.formaPagamentoResponse = response.data.message;
            this.formaPagamentoLink = null;
            this.showFormaPagamentoDialog = true;
            // Atualizar o chat após gerar forma de pagamento
            if (this.currentProtocol) {
              await this.fetchMessagesWithoutLoading();
            }
          }
          // Se tiver formaPagamento vazio, exibir mensagem de erro no diálogo
          else if (
            response.data.formaPagamento !== undefined &&
            response.data.formaPagamento === ""
          ) {
            this.formaPagamentoResponse =
              "Esta forma de pagamento não está habilitada para este documento.";
            this.formaPagamentoLink = null;
            this.showFormaPagamentoDialog = true;
          }
          // Se tiver formaPagamento (URL), exibir no diálogo com opções
          else if (response.data.formaPagamento) {
            this.formaPagamentoResponse = null;
            this.formaPagamentoLink = response.data.formaPagamento;
            this.showFormaPagamentoDialog = true;
            // Atualizar o chat após gerar forma de pagamento
            if (this.currentProtocol) {
              await this.fetchMessagesWithoutLoading();
            }
          } else {
            this.$store?.dispatch("showSnackbar", {
              text: "Resposta inválida da API",
              color: "error",
            });
          }
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao gerar forma de pagamento",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao gerar forma de pagamento:", error);
        this.$store?.dispatch("showSnackbar", {
          text:
            error.response?.data?.message || "Erro ao gerar forma de pagamento",
          color: "error",
        });
      } finally {
        this.loadingFormaPagamento = null;
      }
    },

    // Fechar diálogo de forma de pagamento
    closeFormaPagamentoDialog() {
      this.showFormaPagamentoDialog = false;
      this.formaPagamentoResponse = null;
      this.formaPagamentoLink = null;
    },

    // Copiar link da forma de pagamento para área de transferência
    async copiarLinkFormaPagamento() {
      if (!this.formaPagamentoLink) return;

      try {
        await navigator.clipboard.writeText(this.formaPagamentoLink);
        this.$store?.dispatch("showSnackbar", {
          text: "Link copiado para a área de transferência",
          color: "success",
        });
      } catch (error) {
        console.error("Erro ao copiar link:", error);
        // Fallback para navegadores mais antigos
        const textArea = document.createElement("textarea");
        textArea.value = this.formaPagamentoLink;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.$store?.dispatch("showSnackbar", {
            text: "Link copiado para a área de transferência",
            color: "success",
          });
        } catch (err) {
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao copiar link",
            color: "error",
          });
        }
        document.body.removeChild(textArea);
      }
    },

    // Copiar texto da mensagem de forma de pagamento
    async copiarTextoFormaPagamento() {
      if (!this.formaPagamentoResponse) return;

      try {
        await navigator.clipboard.writeText(this.formaPagamentoResponse);
        this.$store?.dispatch("showSnackbar", {
          text: "Texto copiado para a área de transferência",
          color: "success",
        });
      } catch (error) {
        console.error("Erro ao copiar texto:", error);
        // Fallback para navegadores mais antigos
        const textArea = document.createElement("textarea");
        textArea.value = this.formaPagamentoResponse;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.$store?.dispatch("showSnackbar", {
            text: "Texto copiado para a área de transferência",
            color: "success",
          });
        } catch (err) {
          this.$store?.dispatch("showSnackbar", {
            text: "Erro ao copiar texto",
            color: "error",
          });
        }
        document.body.removeChild(textArea);
      }
    },

    // Enviar mensagem com o link da forma de pagamento
    async enviarMensagemFormaPagamento() {
      if (!this.formaPagamentoLink || !this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Link ou protocolo não encontrado",
          color: "error",
        });
        return;
      }

      // Obter o número do telefone do protocolo selecionado
      let phoneNumberToSend = this.phoneNumber;

      // Se phoneNumber estiver vazio, pegar do protocolo selecionado
      if (!phoneNumberToSend && this.selectedProtocolData) {
        phoneNumberToSend = this.selectedProtocolData.numeroDoContato.replace(
          /^\+?55/,
          "",
        );
      }

      // Se ainda estiver vazio, tentar pegar das mensagens
      if (!phoneNumberToSend && this.messages.length > 0) {
        const firstMessage = this.messages[0];
        if (firstMessage.to) {
          phoneNumberToSend = firstMessage.to.replace(/^\+?55/, "");
        } else if (firstMessage.from) {
          phoneNumberToSend = firstMessage.from.replace(/^\+?55/, "");
        }
      }

      if (!phoneNumberToSend) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone não encontrado",
          color: "error",
        });
        return;
      }

      // Garantir que o número tenha o prefixo 55
      const telefoneFormatado = phoneNumberToSend.startsWith("55")
        ? phoneNumberToSend
        : `55${phoneNumberToSend}`;

      this.sendingMessage = true;

      try {
        const messageData = {
          message: this.formaPagamentoLink,
          to: telefoneFormatado,
          from: this.selectedTemplate
            ? this.selectedTemplate.brokerNumber
            : "558282308177",
          paramsTemplate: "", // String vazia indica que é texto livre
          primeiroContato: false,
        };

        const response = await SonaxService.sendMessage(messageData);

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: "Mensagem enviada com sucesso",
            color: "success",
          });

          // Atualizar mensagens
          await this.fetchMessagesWithoutLoading();

          // Fechar diálogo
          this.closeFormaPagamentoDialog();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao enviar mensagem",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao enviar mensagem",
          color: "error",
        });
      } finally {
        this.sendingMessage = false;
      }
    },

    // Enviar mensagem com o texto da forma de pagamento
    async enviarMensagemTextoFormaPagamento() {
      if (!this.formaPagamentoResponse || !this.currentProtocol) {
        this.$store?.dispatch("showSnackbar", {
          text: "Mensagem ou protocolo não encontrado",
          color: "error",
        });
        return;
      }

      // Obter o número do telefone do protocolo selecionado
      let phoneNumberToSend = this.phoneNumber;

      // Se phoneNumber estiver vazio, pegar do protocolo selecionado
      if (!phoneNumberToSend && this.selectedProtocolData) {
        phoneNumberToSend = this.selectedProtocolData.numeroDoContato.replace(
          /^\+?55/,
          "",
        );
      }

      // Se ainda estiver vazio, tentar pegar das mensagens
      if (!phoneNumberToSend && this.messages.length > 0) {
        const firstMessage = this.messages[0];
        if (firstMessage.to) {
          phoneNumberToSend = firstMessage.to.replace(/^\+?55/, "");
        } else if (firstMessage.from) {
          phoneNumberToSend = firstMessage.from.replace(/^\+?55/, "");
        }
      }

      if (!phoneNumberToSend) {
        this.$store?.dispatch("showSnackbar", {
          text: "Número de telefone não encontrado",
          color: "error",
        });
        return;
      }

      // Garantir que o número tenha o prefixo 55
      const telefoneFormatado = phoneNumberToSend.startsWith("55")
        ? phoneNumberToSend
        : `55${phoneNumberToSend}`;

      this.sendingMessage = true;

      try {
        const messageData = {
          message: this.formaPagamentoResponse,
          to: telefoneFormatado,
          from: this.selectedTemplate
            ? this.selectedTemplate.brokerNumber
            : "558282308177",
          paramsTemplate: "", // String vazia indica que é texto livre
          primeiroContato: false,
        };

        const response = await SonaxService.sendMessage(messageData);

        if (response.data && !response.data.error) {
          this.$store?.dispatch("showSnackbar", {
            text: "Mensagem enviada com sucesso",
            color: "success",
          });

          // Atualizar mensagens
          await this.fetchMessagesWithoutLoading();

          // Fechar diálogo
          this.closeFormaPagamentoDialog();
        } else {
          this.$store?.dispatch("showSnackbar", {
            text: response.data?.message || "Erro ao enviar mensagem",
            color: "error",
          });
        }
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao enviar mensagem",
          color: "error",
        });
      } finally {
        this.sendingMessage = false;
      }
    },

    // Abrir diálogo de interações
    abrirDialogInteracoes() {
      this.showInteracoesDialog = true;
      this.definirPeriodoPadrao();
      this.buscarInteracoes();
    },

    // Fechar diálogo de interações
    closeInteracoesDialog() {
      this.showInteracoesDialog = false;
      this.interacoes = [];
      this.searchInteracoes = "";
    },

    // Definir período padrão (mês atual)
    definirPeriodoPadrao() {
      const hoje = new Date();
      const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
      const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

      // Formato ISO (YYYY-MM-DD) para consulta na API
      this.filtroDataInicio = this.formatDateISO(primeiroDiaMes);
      this.filtroDataFim = this.formatDateISO(ultimoDiaMes);
    },

    // Formatar data no formato ISO (YYYY-MM-DD)
    formatDateISO(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // Buscar interações
    async buscarInteracoes() {
      if (!this.filtroDataInicio || !this.filtroDataFim) {
        this.$store?.dispatch("showSnackbar", {
          text: "Selecione o período para buscar as interações",
          color: "warning",
        });
        return;
      }

      this.loadingInteracoes = true;

      try {
        const response = await SonaxService.getInteracoes(
          this.filtroDataInicio,
          this.filtroDataFim,
        );

        if (response.data) {
          this.interacoes = response.data.map((item) => ({
            ...item,
            // Garantir que todos os campos necessários existam
            idInteracao: item.idInteracao || 0,
            dtInteracao: item.dtInteracao || new Date().toISOString(),
            cliente: item.cliente || "Não informado",
            telefone: item.telefone || "-",
            status: item.status || "Pendente",
          }));
        } else {
          this.interacoes = [];
          this.$store?.dispatch("showSnackbar", {
            text: "Nenhuma interação encontrada",
            color: "info",
          });
        }
      } catch (error) {
        console.error("Erro ao buscar interações:", error);
        this.$store?.dispatch("showSnackbar", {
          text: error.response?.data?.message || "Erro ao buscar interações",
          color: "error",
        });
        this.interacoes = [];
      } finally {
        this.loadingInteracoes = false;
      }
    },

    // Obter cor para o status da interação
    getStatusColor(status) {
      const statusMap = {
        Pendente: "warning",
        "Em Andamento": "info",
        Concluído: "success",
        Cancelado: "error",
        Transferido: "purple",
      };

      return statusMap[status] || "grey";
    },

    // Selecionar telefone da interação
    selecionarTelefone(telefone) {
      if (telefone) {
        // Remover o prefixo +55 se existir
        this.phoneNumber = telefone.replace(/^\+?55/, "");
        // Fechar o diálogo de interações
        this.closeInteracoesDialog();
        // Exibir mensagem de sucesso
        this.$store?.dispatch("showSnackbar", {
          text: `Telefone ${telefone} selecionado com sucesso`,
          color: "success",
        });
      } else {
        this.$store?.dispatch("showSnackbar", {
          text: "Telefone não disponível",
          color: "warning",
        });
      }
    },

    // Obter referência do textarea
    getTextarea() {
      return document.querySelector(".message-input-area textarea");
    },

    // Formatar texto (negrito, itálico, sublinhado)
    formatar(tipo) {
      const textarea = this.getTextarea();
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // Se não há texto selecionado, não faz nada
      if (start === end) return;

      const texto = this.freeTextMessage;
      const selecionado = texto.slice(start, end);

      // Define os marcadores por tipo
      const markers = {
        bold: "*",
        italic: "_",
        underline: "~",
      };

      const m = markers[tipo];

      let novo = selecionado;

      // Se já está formatado, remove a formatação
      if (selecionado.startsWith(m) && selecionado.endsWith(m)) {
        novo = selecionado.substring(1, selecionado.length - 1);
      } else {
        // Senão, adiciona a formatação
        novo = `${m}${selecionado}${m}`;
      }

      // Aplica a mudança no texto
      this.freeTextMessage = texto.slice(0, start) + novo + texto.slice(end);

      // Mantém a seleção após a formatação
      this.$nextTick(() => {
        textarea.focus();
        textarea.selectionStart = start;
        textarea.selectionEnd = start + novo.length;
      });
    },

    // Métodos para o emoji picker
    async toggleEmojiPicker(event) {
      // Carrega o emoji picker se ainda não foi carregado
      await loadEmojiPicker();

      // Posiciona o emoji picker próximo ao botão que foi clicado
      this.emojiPickerPosition = {
        x: event.clientX - 250, // Ajusta para não ficar em cima do botão
        y: event.clientY + 30, // Posiciona abaixo do botão
      };

      // Alterna a visibilidade do emoji picker
      this.showEmojiPicker = !this.showEmojiPicker;

      // Adiciona um listener para fechar o emoji picker quando clicar fora dele
      if (this.showEmojiPicker) {
        setTimeout(() => {
          document.addEventListener("click", this.closeEmojiPicker);
        }, 100);
      }
    },

    closeEmojiPicker(event) {
      // Verifica se o clique foi fora do emoji picker
      const picker = document.querySelector("emoji-picker");
      if (
        picker &&
        !picker.contains(event.target) &&
        !event.target.classList.contains("mdi-emoticon-outline")
      ) {
        this.showEmojiPicker = false;
        document.removeEventListener("click", this.closeEmojiPicker);
      }
    },

    onEmojiClick(event) {
      // Insere o emoji na posição atual do cursor ou no final do texto
      const emoji = event.detail.unicode;
      this.freeTextMessage += emoji;

      // Fecha o emoji picker após selecionar um emoji
      this.showEmojiPicker = false;
      document.removeEventListener("click", this.closeEmojiPicker);
    },

    // Métodos para identificar tipos de arquivos
    isImage(url) {
      if (!url) return false;
      return /\.(jpg|jpeg|png|gif|webp|bmp|svg)($|\?)/i.test(url);
    },

    isAudio(url) {
      if (!url) return false;
      return /\.(mp3|ogg|wav|m4a|aac|flac|opus)($|\?)/i.test(url);
    },

    isVideo(url) {
      if (!url) return false;
      return /\.(mp4|webm|mov|m4v|avi|mkv|3gp)($|\?)/i.test(url);
    },

    // Método para abrir a pré-visualização de mídia
    openMediaPreview(url) {
      if (!url) return;
      // Abre o arquivo em uma nova aba
      window.open(url, "_blank");
    },

    // Scroll automático para o final do chat com estratégia multifásica (evita parar no meio em textos longos)
    scrollToBottom(force = false) {
      const scrollAction = () => {
        const chatContainer =
          document.querySelector(".chat-panel .chat-container") ||
          document.querySelector(".chat-container");
        if (chatContainer) {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
        if (
          this.$refs.chatBottomAnchor &&
          typeof this.$refs.chatBottomAnchor.scrollIntoView === "function"
        ) {
          this.$refs.chatBottomAnchor.scrollIntoView({
            block: "end",
            behavior: "auto",
          });
        }
      };

      this.$nextTick(() => {
        scrollAction();
        if (typeof window !== "undefined" && window.requestAnimationFrame) {
          window.requestAnimationFrame(() => {
            scrollAction();
            window.requestAnimationFrame(scrollAction);
          });
        }
        setTimeout(scrollAction, 50);
        setTimeout(scrollAction, 150);
        setTimeout(scrollAction, 300);
        if (force) {
          setTimeout(scrollAction, 600);
          setTimeout(scrollAction, 1000);
        }
      });
    },
  },
};
</script>

<style scoped>
.emoji-picker-container {
  position: fixed;
  z-index: 4;
}

.file-message {
  margin: 5px 0;
}

.file-message img {
  max-width: 100%;
  border-radius: 4px;
  transition: transform 0.2s;
}

.file-message img:hover {
  transform: scale(1.02);
}

.media-container {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media-player-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.media-icon {
  font-size: 24px;
}

.audio-player {
  width: 250px;
  height: 40px;
  border-radius: 20px;
  outline: none;
}

.chat-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.message-bubble {
  max-width: 70%;
  border-radius: 8px;
  word-break: break-word;
}

.outgoing-message {
  background-color: #cfe8ff;
  border-left: 3px solid #1565c0;
  margin-left: auto;
  border-top-right-radius: 0;
}

.incoming-message {
  background-color: #eceff1;
  border-right: 3px solid #90a4ae;
  margin-right: auto;
  border-top-left-radius: 0;
}

.outgoing-message-historico {
  background-color: #e6f3ff;
  border-left: 3px solid #90caf9;
  margin-left: auto;
  border-top-right-radius: 0;
}

.incoming-message-historico {
  background-color: #e8f5e9;
  align-self: flex-start;
  margin-right: auto;
  border-top-left-radius: 0;
}
.chat-card {
  min-height: 500px;
}

.protocols-card {
  min-height: 500px;
}

.protocols-list-container {
  max-height: 100%;
  overflow-y: auto;
}

.client-details-card {
  min-height: 500px;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.expansion-panel {
  border-radius: 8px;
  border: 1px solid rgb(224 224 224);
}

.message-bubble.note-message {
  background-color: #f5f5f5;
  border-radius: 8px;
  color: #555;
  font-style: italic;
  max-width: 90%;
  margin: 0 auto;
  text-align: center;
}

.text-formatting-buttons {
  display: flex;
  gap: 4px;
  margin-left: 2px;
}

.note-message {
  background-color: #fff8e1;
  border-right: 3px solid #ffb300;
  align-self: flex-start;
  margin-right: auto;
  border-top-left-radius: 0;
}

.note-message-historico {
  background-color: #fff8e1;
  border-right: 3px solid #ffb300;
  align-self: flex-start;
  margin-right: auto;
  border-top-left-radius: 0;
}

.protocol-header-info {
  gap: 6px;
  min-width: 0;
}

.protocol-header-info .v-chip {
  max-width: 100%;
}

::v-deep .protocol-header-info .v-chip__content {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 960px) {
  .consulta-chat-page .container {
    max-width: 100% !important;
  }

  .consulta-chat-page .mx-12 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .consulta-chat-page .mt-8 {
    margin-top: 8px !important;
  }

  .consulta-chat-layout {
    padding: 0 !important;
  }

  .consulta-chat-row {
    margin: 0 !important;
    position: relative;
    min-height: calc(100vh - 160px);
  }

  .protocols-panel,
  .chat-panel {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 !important;
  }

  .protocols-panel {
    position: relative;
    z-index: 0;
  }

  .chat-panel {
    position: relative;
    z-index: 0;
  }

  .protocols-card,
  .chat-card,
  .client-details-card {
    height: calc(100vh - 160px) !important;
    min-height: calc(100vh - 160px) !important;
    border-radius: 0 !important;
  }

  .protocol-header-info {
    flex-wrap: nowrap !important;
  }

  .protocol-header-info .v-chip {
    min-width: 0;
  }

  .message-bubble {
    max-width: 88%;
  }

  .message-input-area {
    align-items: flex-end !important;
  }

  .message-input-area .v-btn {
    min-width: 42px !important;
    padding: 0 10px !important;
  }

  .emoji-picker-container {
    left: 8px !important;
    right: 8px;
    max-width: calc(100vw - 16px);
  }
}
</style>
